export default {
  "The Operator is not registered. Do you want to send a notification to operator to join the platform via email?": "Operator tidak terdaftar. Apakah Anda ingin mengirim notifikasi kepada operator untuk bergabung dengan platform melalui email?",
    "Do you want to download all attached files in PDF format?": "Apakah Anda ingin mengunduh semua berkas terlampir dalam format PDF?",
  deforestation: {
    geolocationPrivacyTT: "Pengaturan privasi geolokasi memungkinkan pengguna untuk mengontrol visibilitas data lokasi mereka. Saat diaktifkan, lokasi akan ditandai sebagai rahasia, membatasi aksesnya. Saat dinonaktifkan, lokasi akan tersedia untuk umum.",
  geolocationPrivacySubHeading: "Pengaturan privasi geolokasi memungkinkan pengguna untuk mengontrol visibilitas data lokasi mereka.",
    unregistered: "tidak terdaftar",
    sendToOperator: "Bagikan dengan Operator",
    eudrVerificationNo: "Nomor Verifikasi",
    eudrVerificationNoTT: "Nomor Verifikasi yang diterima dari EUDR",
    producerData: {
      addProducers: "TAMBAHKAN PRODUSER BARU",
      countryInfo:
        "Kolom untuk memasukkan atau menampilkan negara yang terkait dengan produsen.",
    },
    selectFileToUpload: "Pilih file untuk mengunggah data",
    uploadExistingAssessment: "Unggah Penilaian yang Sudah Ada",
    completeDimitraAssessment: "Penilaian oleh Operator atau Pemasok",
    assessmentByFarmer: "Penilaian oleh Petani",
    uploadedToEU: "Diunggah ke Portal UE",
    pending: "Menunggu",
    underReview: "Sedang Ditinjau",
    compliant: "Patuh",
    combinedComplianceLowRisk: "Risiko Rendah",
    combinedComplianceMediumRisk: "Risiko Sedang",
    mergedComplianceStatus: "Status Risiko",
    nonCompliant: "Tidak Mematuhi",
    analyzeDeforestation: "Menganalisis Deforestasi",
    analyzingWildfireReports: "Menganalisis Laporan Kebakaran Hutan",
    analyzingDeforestation: "Menganalisis Deforestasi",
    readyToProceed: "Siap Untuk Melanjutkan",
    processingFarm: "Memproses Perkebunan",
    mitigationRequired: "Diperlukan Mitigasi",
    confirmationTitle: "Konfirmasi",
    "operatorRegisterConfirmation":"Operator belum terdaftar. Apakah Anda ingin mengirim notifikasi kepada operator untuk bergabung ke platform melalui email?",

    veryHighDeforestationProbability: "Probabilitas Deforestasi Sangat Tinggi",
    highDeforestationProbability: "Probabilitas Deforestasi Tinggi",
    mediumDeforestationProbability: "Probabilitas Deforestasi Sedang",
    lowDeforestationProbability: "Probabilitas Deforestasi Rendah",
    veryLowDeforestationProbability: "Probabilitas Deforestasi Sangat Rendah",
    zeroNegligibleDeforestationProbability:
      "Probabilitas Deforestasi Nol/Dapat Diabaikan",
    manuallyMitigated: "Mitigasi Manual",

    internalReferenceNumberMustBeAlphanumeric:
      "Nomor referensi internal harus berupa alfanumerik",
    atLeastOneOfSupplierIdOrSupplierNameIsRequired:
      "Setidaknya salah satu dari ID Pemasok atau Nama Pemasok diperlukan",
    atLeastOneExporterIsRequired: "Minimal satu eksportir diperlukan",
    atLeastOneOfOperatorIdOrOperatorNameIsRequired:
      "Setidaknya salah satu dari ID Operator atau Nama Operator diperlukan",
    netMassIsRequired: "Massa bersih diperlukan",
    netMassMustBeValid: "Massa bersih harus valid",
    thisFieldIsRequired: "Kolom ini wajib diisi",
    volumeMustBeNumeric: "Volume harus berupa angka",
    nameIsRequired: "Nama wajib diisi",
    lastNameIsRequired: "Nama belakang wajib diisi",
    firstNameIsRequired: "Nama depan wajib diisi",
    countryIsRequired: "Negara wajib diisi",

    confirmPdfDownload:
      "Apakah Anda ingin mengunduh semua lampiran dalam format PDF?",
    confirmJsonDownload:
      "Apakah Anda ingin mengunduh semua lampiran dalam format JSON?",
    basicFinalFarmListWithStatus: "Daftar final pertanian dasar dengan status",
    detailedInformationIncludingDescriptionOfRiskMitigationActivities:
      "Informasi terperinci, termasuk deskripsi kegiatan mitigasi risiko",
    completeDocumentIncludingRiskMitigationAndAttachedDocuments:
      "Dokumen lengkap, termasuk mitigasi risiko dan dokumen lampiran",

    existing: "Ada",
    survey: "Survei",

    operatorInformation: "Informasi Operator",

    reportAddedSuccessfully: "Laporan berhasil ditambahkan",
    reportUpdatedSuccessfully: "Laporan berhasil diperbarui",
    itemDeletedSuccessfully: "Item berhasil dihapus.",
    reportDeletedSuccessfully: "Laporan berhasil dihapus",
    anErrorOccurredWhileDeletingTheReport:
      "Terjadi kesalahan saat menghapus laporan.",

    valueMustBeBetween02And40: "Nilai harus antara 0,2 dan 40",

    EUDRDeforestationStatusTT:
      "Pemilihan status deforestasi. Kemungkinan Deforestasi Tinggi: Kategori khusus penilaian risiko yang diberikan ke area geografis tertentu berdasarkan kemungkinan deforestasi atau degradasi hutan. Ini membantu menentukan persyaratan uji tuntas bagi operator yang menempatkan komoditas penting (seperti kakao, kopi, dll.) atau produk yang mengandung atau dibuat dari komoditas tersebut di pasar UE. Kemungkinan Deforestasi Rendah: Kategori penilaian risiko untuk area geografis yang dianggap tidak mungkin mengalami deforestasi atau degradasi hutan yang signifikan. Penunjukan ini memengaruhi persyaratan uji tuntas bagi operator yang menempatkan komoditas atau produk dari area ini di pasar UE. Kemungkinan Deforestasi Nol/Tidak Signifikan: Kemungkinan deforestasi sangat rendah atau tidak ada. Ini menunjukkan bahwa risiko atau dampak deforestasi dianggap sangat kecil atau tidak signifikan.",

    complianceRiskWarnings: "Peringatan Risiko Kepatuhan",
    complianceRiskWarningsInfo:
      "Menampilkan judul bagian, menunjukkan bahwa area ini berfokus pada peringatan terkait risiko kepatuhan dalam proses uji tuntas.",
    locationVerificationTT:
      "Mengacu pada proses konfirmasi dan validasi lokasi geografis situs produksi sebagai bagian dari prosedur uji tuntas. Ini mencakup memastikan bahwa detail lokasi yang diberikan, seperti koordinat atau alamat, secara akurat mewakili lokasi fisik tempat kegiatan produksi berlangsung. Verifikasi ini penting untuk menilai dampak lingkungan, kepatuhan penggunaan lahan, dan akurasi data yang dilaporkan dalam laporan uji tuntas.",

    netMassKg: "Massa Bersih (kg)",
    volumeM3: "Volume (m3)",
    warning: "Peringatan",

    productionPlacesTT: "Lokasi di mana barang diproduksi atau dibudidayakan.",
    productionPlacesCountryInfo:
      "Sebuah badan teritorial yang berbeda dengan pemerintahan dan batasnya sendiri.",
    productionPlacesProducersInfo:
      "Entitas yang bertanggung jawab untuk menciptakan atau menumbuhkan barang.",
    totalsTT:
      "Bagian 'Total' memberikan ringkasan indikator kuantitatif utama untuk seluruh kumpulan data atau laporan. Ini mengumpulkan data untuk memberikan pengguna gambaran cepat tentang metrik keseluruhan, seperti massa total produk, volume total produk, luas tempat produksi, dll., yang terlibat dalam laporan uji tuntas.",

    AnalysisOfDeforestationStatusTT:
      "Analisis keadaan deforestasi saat ini dalam area tertentu, biasanya dilakukan untuk menilai dampak lingkungan atau kepatuhan terhadap upaya konservasi.",

    complete: "Lengkap",

    undoDelete: "Batalkan Penghapusan",

    verifyingLocationsData: "Memverifikasi data lokasi...",
    crossCheckingWithProductionPlaces:
      "Memeriksa silang dengan tempat produksi...",
    almostTherePleaseHoldOn: "Hampir selesai, harap tunggu...",
    LocationVerifiedSuccessfully: "Lokasi berhasil diverifikasi!",
    allProductionPlacesAndLocationsHaveBeenConfirmed:
      "Semua tempat produksi dan lokasi telah dikonfirmasi!",
    errorCheckingOverlaps: "Kesalahan memeriksa tumpang tindih.",
    farmIsBiggerThan4HectaresItNeedsToBeAPolygon:
      "Lahan lebih besar dari 4 hektar, harus berbentuk poligon",
    failedToFetchSettings: "Gagal mengambil pengaturan",
    farmCountryNotDefined: "Negara lahan tidak ditentukan.",
    theGeofencesSupposeToBeIn: "Geofence seharusnya berada di",
    butItsIn: "tetapi ada di",
    geofenceIsInOcean: "Geofence atau sebagian dari geofence berada di laut.",

    existingReport: "Laporan Deforestasi yang Ada",
    dimitraReport: "Laporan Deforestasi Dimitra",
    oneForAllFarms: "Satu untuk Semua Perkebunan",
    oneForEachFarm: "Satu untuk Setiap Perkebunan",

    anErrorOccuredWhileFetchingTheDeforestationReport:
      "Terjadi kesalahan saat mengambil laporan deforestasi.",

    attachRiskMigrationDocTT:
      "Menunjukkan tindakan menghubungkan atau mengaitkan satu dokumen dengan semua pertanian yang teridentifikasi memiliki risiko deforestasi, biasanya untuk tujuan dokumentasi atau kepatuhan regulasi.",
    country: "Negara",
    noOfFarms: "Jumlah Ladang",
    deforestationComplianceReport: "Laporan Kepatuhan Deforestasi",
    noDeforestationComplianceReport:
      "Tidak Ada Laporan Kepatuhan Deforestasi Ditemukan",
    loadingDeforestationComplianceReport:
      "Memuat Laporan Kepatuhan Deforestasi",
    farmName: "Nama Perkebunan",
    farmRegistrationId: "ID Registrasi Perkebunan",
    farmerName: "Nama Petani",
    farmerRegistrationId: "ID Registrasi Petani",
    uniqueFarmerId: "ID Petani Unik",
    uniqueFarmId: "ID Perkebunan Unik",
    farmLocation: "Lokasi Perkebunan",
    area: "Area",
    farmAddress: "Alamat Perkebunan",
    dateOfRequest: "Tanggal Permintaan",
    status: "Status",
    settings: "Pengaturan",
    farmLatitude: "Lintang Perkebunan",
    farmLongitude: "Bujur Perkebunan",
    shareQRCode: "Bagikan Kode QR",
    copy: "Salin",
    allCountries: "Semua Negara",
    allRegions: "Semua Daerah",
    allFarms: "Semua Perkebunan",
    viewCertificate: "Lihat Sertifikat",
    assignmentIssued: "Tugas Diberikan",
    complianceCertification: "Sertifikasi Kepatuhan",
    noComplianceCertification: "Tidak Ada Sertifikasi Kepatuhan Ditemukan",
    loadingComplianceCertification: "Memuat Sertifikasi Kepatuhan",
    eudrForestAssessment: "Evaluasi Hutan EUDR",
    assessmentReport: "Laporan Evaluasi",
    downloadPDF: "Unduh PDF",
    back: "Kembali",
    farmDetails: "Detail Perkebunan",
    dimitraFarmId: "ID Perkebunan Dimitra",
    dimitraFermerId: "ID Petani Dimitra",
    totalGeofenceAreaHA: "Total Area Geofence (HA)",
    forestLossHA: "Kehilangan Hutan (HA)",
    forestGainHA: "Pendapatan Hutan (HA)",
    forestUnchangedHA: "Hutan Tidak Berubah (HA)",
    shareCertificate: "Bagikan Sertifikat",
    forestUnchanged: "Hutan Tidak Berubah",
    forestLoss: "Kehilangan Hutan",
    forestGain: "Pendapatan Hutan",
    totalGeofenceArea: "Total Luas Geofence",
    deforestationProbability: "Probabilitas Deforestasi",
    colorCode: "Kode Warna",
    geofenceArea: "Area Geofence",
    percentageOfGeofenceArea: "Persentase Area Geofence",
    view: "Tampilan",
    customization: "Penyesuaian",
    recordsPerpage: "Rekaman per Halaman",
    restoreDefault: "Pulihkan Default",
    apply: "Terapkan",
    forestAssessmentHelp:
      "Jika Anda memiliki pertanyaan tentang laporan ini atau memerlukan bantuan memahaminya, hubungi kami melalui Help Desk.",
    overallDeforestationProbability: "Probabilitas Deforestasi Keseluruhan",
    zeroOrNeglegible: "Nol atau Tidak Signifikan",
    high: "Tinggi",
    allStatus: "Semua Status",
    low: "Rendah",
    assessmentIssued: "Evaluasi Dikeluarkan",
    certificateIssued: "Sertifikat Dikeluarkan",
    assessmentNo: "Nomor Evaluasi",
    blockchainCertificateDesc:
      "Hash Validasi Sertifikat Blockchain Akan Tersedia Setelah Penerimaan Sertifikat",
    blockchainValidation: "Validasi Sertifikat Blockchain",
    openBlockchainPage: "Buka Halaman Blockchain",
    clickLinkDesc:
      "Klik pada tautan di atas untuk memvalidasi sertifikat di blockchain",
    "Zero/Negligible Deforestation Probability":
      "Probabilitas Deforestasi Nol/Negligible",
    "Zero Deforestation Probability": "Probabilitas Deforestasi Nol",
    "Low Deforestation Probability": "Probabilitas Deforestasi Rendah",
    "High Deforestation Probability": "Probabilitas Deforestasi Tinggi",
    "Very Low Deforestation Probability":
      "Probabilitas Deforestasi Sangat Rendah",
    "Medium Deforestation Probability": "Probabilitas Deforestasi Sedang",
    "Very High Deforestation Probability":
      "Probabilitas Deforestasi Sangat Tinggi",
    disputeReason: "Alasan Sengketa",
    disputeStatus: "Status Sengketa",
    farmRegId: "ID Reg. Pertanian",
    productionPlaceId: "ID Tempat Produksi",
    disputeId: "ID Sengketa",
    disputeArea: "Ukuran Area",
    disputeResolution: "Penyelesaian Sengketa",
    selectDefaultMeasurementUnit: "Pilih Unit Pengukuran Default",
    selectDefaultMeasurementUnitInfo:
      "Memungkinkan pemilihan satuan default untuk pengukuran, termasuk menentukan satuan, menetapkan batas maksimum, dan menandainya sebagai opsi default.",
    maxLimit: "Batas Maksimum",
    maxLimitInfo:
      "Menetapkan nilai atau ambang batas tertinggi yang diizinkan untuk parameter tertentu.",
    asDefault: "Tandai sebagai Default",
    productMass: "Massa Produk",
    productMassUnitInfo: "Menentukan satuan untuk mengukur massa suatu produk.",
    volumeUnitInfo: "Menentukan satuan untuk mengukur volume suatu produk.",
    operatorInfo:
      "Merujuk pada individu atau entitas yang bertanggung jawab untuk mengelola atau mengoperasikan sistem atau proses.",
    supplierInfo:
      "Entitas yang menyediakan barang atau layanan kepada entitas lain.",
    userTypeInfo:
      "Mengklasifikasikan individu atau entitas berdasarkan peran atau izin mereka dalam sistem.",
    unit: "Satuan",
    userType: "Tipe Pengguna",
    eudrPortalApiKeys: "Kunci API Portal EUDR",
    apiKey: "Kunci API",
    apiSecret: "Rahasia API",
    headingCreatedSuccessfully: "Judul berhasil dibuat",
    headingOrderSuccessfullyUpdated: "Urutan berhasil diperbarui",
    headingUpdatedSuccessfully: "Diperbarui dengan sukses",
    assessmentRiskMitigationLvl: "Tingkat Mitigasi Risiko Penilaian",
    assessmentRiskMitigationLvlInfo:
      "Mengategorikan tingkat keparahan risiko yang terkait dengan penggunaan lahan, praktik kehutanan, dan ekspansi pertanian. Tingkat ini membantu mengidentifikasi dampak potensial dari kegiatan pada area hutan dan membimbing tindakan yang tepat untuk mengurangi konsekuensi negatif. Mengategorikan tingkat strategi mitigasi risiko, termasuk sangat tinggi, tinggi, sedang, rendah, dan nol/tidak signifikan.",
    dynamicExpiryTime: "Periode Kedaluwarsa Dinamis",
    dynamicExpiryTimeInfo:
      "Menetapkan periode waktu setelah mana data atau pengaturan tertentu kedaluwarsa secara otomatis. Mengonfigurasi pengaturan terkait laporan deforestasi, termasuk opsi untuk pembaruan otomatis.",
    eudrDeforestationAssessment: "Penilaian Deforestasi EUDR",
    autoRenewalIf:
      "Perpanjangan Otomatis Saat Ditambahkan ke Laporan Due Diligence",
    declarationStatements: "Pernyataan Deklarasi",
    declarationStatementsInfo:
      "Pernyataan yang dibuat oleh pihak yang bertanggung jawab yang memverifikasi akurasi, kelengkapan, dan keaslian informasi yang terkandung dalam laporan.",
    filterDeclaration: "Saring Pernyataan Deklarasi",
    declarationTitle: "Judul Deklarasi",
    declarationTitleInfo:
      "Judul atau heading untuk pernyataan deklarasi, memberikan konteks atau merangkum isinya.",
    applicableCountry: "Negara yang Berlaku",
    applicableCountryInfo:
      "Mendaftarkan negara-negara yang berlaku untuk pengaturan atau peraturan tertentu.",
    addMore: "Tambahkan Lagi",
    autoRenewal: "Perpanjangan Otomatis",
    createNewAssessment: "Buat Penilaian Baru",
    userDimitraAssessment: "Gunakan Penilaian Dimitra",
    shipmentList: "Daftar Pengiriman",
    generalData: "Data Umum",
    check: "Periksa",
    allProducer: "Semua Produsen",
    very_high: "Sangat Tinggi",
    very_low: "Sangat Rendah",
    tooltip: {
      dimitraFarmId:
        "Pengenal unik yang terkait dengan perkebunan tertentu dalam sistem Dimitra.",
      farmName: "Nama yang ditetapkan untuk perkebunan.",
      farmRegistrationId: "Nomor registrasi perkebunan.",
      farmLocation: "Koordinat geografis atau lokasi spesifik perkebunan.",
      dimitraFermerId:
        "Pengenal yang berbeda yang terkait dengan petani individu dalam sistem Dimitra.",
      farmerName:
        "Identifikasi individu yang bertanggung jawab atas perkebunan.",
      farmerRegistrationId: "Nomor registrasi petani.",
      assessmentNo: "Nomor unik yang diberikan untuk penilaian.",
    },
    red: "Merah",
    Yellow: "Kuning",
    transparent: "Transparan",
    zeroOrNeglegibleProbability:
      "Probabilitas Deforestasi Nol/Tidak Signifikan",
    eudrComplianceStatus: "Status Kepatuhan EUDR",
    zeroOrNegligible: "Nol/Nihil",
    veryHigh: "Sangat Tinggi",
    medium: "Sedang",
    veryLow: "Sangat Rendah",
    darkRed: "Merah Gelap",
    brightRed: "Merah Cerah",
    orange: "Oranye",
    lightBlue: "Biru Muda",
    teal: "Hijau Biru",
    zeroOrNegligibleProbability: "Probabilitas Deforestasi Nol/Dapat Diabaikan",
    riskDetected: "Risiko Terdeteksi",
    zeroOrNegligibleRisk: "Risiko Nol/Tidak Signifikan",
    veryLowProbability: "Probabilitas Deforestasi Sangat Rendah",
    lowProbability: "Probabilitas Deforestasi Rendah",
    mediumProbability: "Probabilitas Deforestasi Sedang",
    highProbability: "Probabilitas Deforestasi Tinggi",
    veryHighProbability: "Probabilitas Deforestasi Sangat Tinggi",
    locationName: "Nama Lokasi",
    Orange: "Oranye",
    approve: "Setujui",
    approveMessage:
      "Apakah Anda yakin ingin menyetujui laporan ini? Dengan menyetujui laporan ini, laporan tersebut akan diunggah secara permanen ke blockchain. Tautan blockchain dan kode QR akan dibuat, dan tidak ada pembaruan atau penyuntingan lebih lanjut yang dapat dilakukan. Apakah Anda ingin melanjutkan?",
    dueDeligence: "Kewajiban Hati-hati",
    supplierInformation: "Informasi Pemasok",
    name: "Nama",
    lastName: "Nama Belakang",
    email: "E-mail",
    phoneNumber: "Nomor Telepon",
    enterSupplierName: "Masukkan Nama Pemasok",
    enterSupplierLastName: "Masukkan Nama Belakang Pemasok",
    enterSupplierFirstName: "Masukkan Nama Depan Pemasok",
    enterOperatorName: "Masukkan Nama Operator",
    enterPhoneNumber: "Masukkan Nomor Telepon",
    whoWillAddPlace: "Siapa yang Akan Menambahkan Data Tempat Produksi?",
    companyId: "ID Perusahaan",
    activity: "Aktivitas",
    placeOfActivity: "Tempat Aktivitas",
    countryOfActivity: "Negara Aktivitas",
    operatorPlaceOfActivity: "Tempat Aktivitas Operator",
    operatorCountryOfActivity: "Negara Aktivitas Operator",
    countryOfEntry: "Negara Masuk",
    productDetail: "Detail Produk",
    subProduct: "Sub-Produk",
    productionDescription: "Deskripsi Produk",
    netMass: "Massa Bersih",
    volume: "Volume",
    scietificName: "Nama Ilmiah",
    commonName: "Nama Umum",
    eudrDueDeligenceReports: "Laporan Kewajiban Hati-hati EUDR",
    EUDRAssessmentReport: "Laporan Penilaian EUDR",
    eudrRefNo: "Nomor Referensi EUDR",
    eudrRefNoInfo:
      "Fungsi untuk menemukan informasi spesifik terkait dengan pengiriman.",
    statusInfo:
      "Status saat ini dari pengiriman terkait dengan laporan uji tuntas.",
    eudrAndInternalRefNo: "Nomor Referensi EUDR / Internal",
    exporterAndSupplier: "Eksportir & Pemasok",
    internalRefNo: "Nomor Referensi Internal",
    farmsAndQuantity: "Pertanian & Kuantitas",
    quantity: "Kuantitas",
    product: "Produk",
    lastUpdated: "Terakhir Diperbarui",
    dueDeligenceStatus: "Status Kewajiban Hati-hati",
    riskStatus: "Status Risiko",
    riskStatusHigh: "Risiko Tinggi",
    riskStatusMedium: "Risiko Sedang",
    riskStatusZeroNegligible: "Nol/Dapat Diabaikan",
    localComplianceStatus: "Status Kepatuhan Lokal",
    edurDueDeligenceStatus: "Status Kewajiban Hati-hati EUDR",
    edurDueDeligenceReport: "Laporan Kewajiban Hati-hati EUDR",
    reject: "Tolak",
    discard: "Buang",
    saveAndContinueLater: "Simpan & Lanjutkan Nanti",
    requestAdditionalInformation: "Minta Informasi Tambahan",
    requestAdditionalInformationShort: "Minta Info Tambahan",
    uploadToEudr: "Unggah ke EUDR",
    submitForApproval: "Kirim untuk Persetujuan",
    submitForApprovalConfirmationPtsi: "Apakah Anda yakin ingin mengirimkan laporan ini untuk persetujuan? Laporan akan dibagikan dengan PTSI setelah dikirim.",
    submitForApprovalConfirmationKenya: "Apakah Anda yakin ingin mengirimkan laporan ini untuk persetujuan? Laporan akan dibagikan dengan Kenya setelah dikirim.",
    productionPlaces: "Tempat Produksi",
    next: "Lanjut",
    dueDeligenceReportCreation: "Pembuatan Laporan Kewajiban Hati-hati",
    producer: "Produsen",
    select: "Pilih",
    productionPlacesFarmAndFarmId:
      "Tempat produksi (Perkebunan) & ID perkebunan",
    producerName: "Nama Produsen",
    addressOfProduction: "Alamat Produksi",
    geofence: "Pagar Geografis",
    areaHa: "Area (ha)",
    editGeofence: "Edit Pagar Geografis",
    totals: "Total",
    locationVerification: "Verifikasi Lokasi",
    AnalysisOfDeforestationStatus: "Analisis Status Deforestasi",
    EUDRDeforestationStatus: "Status Deforestasi EUDR",
    productionPlaceStatus: "Status",
    removeAllLowRiskFarm: "Hapus semua perkebunan berisiko rendah",
    removeAllHighRiskFarm: "Hapus semua perkebunan berisiko tinggi",
    removeAllMediumRiskFarm: "Hapus semua perkebunan berisiko sedang",
    attachRiskMigrationDoc:
      "Lampirkan satu dokumen mitigasi risiko untuk semua perkebunan berisiko tinggi",
    removedFarms: "Perkebunan yang dihapus dari daftar",
    generateCertificate: "Hasilkan Sertifikat",
    viewDisputeHistory: "Lihat Riwayat Sengketa",
    reportDetails: "Detail Laporan",
    productionPlace: "Tempat Produksi",
    regionalRiskAssessment: "Penilaian Risiko Regional",
    EUDRDeforestationAssessment: "Penilaian Deforestasi EUDR",
    complianceStatusReview: "Kepatuhan DB Lokal",
    complianceStatusReviewTT:
      "Tinjau indikator lampu lalu lintas kepatuhan untuk setiap tempat produksi berdasarkan analisis deforestasi dan data risiko kabupaten IYB.",
    complianceStatusReviewDesc:
      "Tinjau indikator kepatuhan setiap tempat produksi sebelum melanjutkan. Hijau berarti patuh, kuning adalah peringatan, dan merah memerlukan tindakan atau penghapusan.",
    complianceTrafficLight: "Indikator Risiko",
    viewComplianceIndicator: "Lihat detail indikator risiko",
    complianceTrafficLightCriticalRiskCount: "{count} perkebunan berisiko Kritis.",
    complianceTrafficLightCriticalRiskMustRemove: "Perkebunan ini tidak dapat dilanjutkan — harus dihapus sebelum melanjutkan.",
    complianceTrafficLightQuickActions: "Tindakan Cepat",
    complianceTrafficLightRemoveAllCriticalRiskFarms: "Hapus Semua Perkebunan Risiko Kritis ({count})",
    complianceTrafficLightUploadMitigationDocument: "Unggah Dokumen Mitigasi",
    complianceTrafficLightBulkUploadHint: "Unggah satu dokumen untuk menerapkan mitigasi ke semua perkebunan yang masih memerlukannya.",
    wildfireBulkGenerateButton: "Buat Semua Laporan Kebakaran Hutan",
    wildfireBulkHint: "Buat laporan kerentanan kebakaran tingkat lahan untuk semua lokasi produksi dalam laporan ini sekaligus.",
    wildfireBulkAnalyzing: "Menganalisis...",
    wildfireBulkDialogTitle: "Pembuatan Laporan Kebakaran Hutan Massal",
    wildfireBulkConfirmMessage: "Ini akan mengirimkan setiap lokasi produksi dalam laporan ini ({count} total) untuk diproses secara latar belakang. Laporan besar dapat memakan waktu.",
    wildfireBulkStart: "Mulai",
    wildfireBulkCancel: "Batal",
    wildfireBulkSubmitting: "Mengirimkan batch...",
    wildfireBulkPolling: "Membuat laporan kebakaran hutan untuk semua lokasi produksi — ini dapat memakan waktu untuk laporan besar...",
    wildfireBulkClose: "Tutup",
    wildfireBulkErrorColumn: "Kesalahan",
    complianceTrafficLightMitigationUploaded: "Mitigasi diunggah ✓",
    complianceTrafficLightUploadMitigationRequired: "Unggah Mitigasi (Wajib)",
    complianceTrafficLightLegendCriticalRisk: "Risiko Kritis",
    trafficLightNotAvailable: "Tidak Tersedia",
    complianceTrafficLightCannotProceed: "Tidak Dapat Melanjutkan",
    complianceTrafficLightYesProceed: "Ya, Lanjutkan",
    complianceTrafficLightRemoveAllFarmsTitle: "Hapus Semua Perkebunan {riskLevel}?",
    complianceTrafficLightCannotBeUndone: "Tindakan ini tidak dapat dibatalkan.",
    complianceTrafficLightYesRemove: "Ya, Hapus",
    complianceTrafficLightHighRiskCount: "Risiko Tinggi ({count})",
    complianceTrafficLightMediumRiskCount: "Risiko Sedang ({count})",
    complianceTrafficLightSelectDocument: "Pilih dokumen",
    complianceTrafficLightAttachDocument: "Lampirkan Dokumen",
    complianceTrafficLightRevisionRequested: "Revisi diminta:",
    complianceTrafficLightUploadedDocuments: "Dokumen yang diunggah",
    complianceTrafficLightView: "Lihat",
    complianceTrafficLightRemove: "Hapus",
    complianceTrafficLightSelectMitigationDocument: "Pilih dokumen mitigasi",
    complianceTrafficLightUpdateDocument: "Perbarui Dokumen",
    complianceTrafficLightUpload: "Unggah",
    complianceTrafficLightMediumRiskWarning: "Peringatan Risiko Sedang",
    complianceTrafficLightFarmMediumRisk: "Perkebunan {name} berisiko Sedang.",
    complianceTrafficLightGotIt: "Mengerti",
    complianceTrafficLightReadyToProceedTitle: "Siap melanjutkan?",
    complianceTrafficLightCriticalRiskProceedBody: "Anda memiliki {count} perkebunan Risiko Kritis yang harus dihapus sebelum dapat melanjutkan ke langkah berikutnya.",
    complianceTrafficLightAllFarmsGoodBody: "Semua perkebunan terlihat baik. Apakah Anda yakin ingin pindah ke langkah berikutnya?",
    complianceTrafficLightMitigationFarmNotFound: "Tidak dapat menemukan perkebunan untuk pengajuan ulang mitigasi. Harap unggah dokumen dari daftar.",
    EUDRcountry:
      "Negara tempat pertanian berada, yang ditautkan ke produk dalam laporan uji tuntas. Ini membantu memastikan ketertelusuran geografis sebagaimana diwajibkan oleh peraturan EUDR.",
    legalInformation: "Informasi Hukum",
    finalReport: "Laporan Akhir",
    editGeolocation: "Edit Geolokasi",
    manuallyAddData: "Tambahkan Data Secara Manual",
    drawGeofence: "Gambar Pagar Geografis",
    uploadFile: "Unggah Berkas",
    attachRiskMitigationDocumentForAllNonCompliantFarms: "Lampirkan Dokumen Mitigasi Risiko untuk Semua Pertanian yang Tidak Mematuhi",
    attachOneRiskMitigationDocumentForAllNonCompliantFarms: "LAMPIRKAN SATU DOKUMEN MITIGASI RISIKO UNTUK SEMUA PERTANIAN YANG TIDAK MEMATUHI",
    fileRequired: "File wajib diisi",
    errorMitigatingFarms: "Kesalahan dalam mitigasi pertanian",
    submit: "Kirim",
    typeyourlocation: "Ketik nama/alamat lokasi Anda",
    numberOfPoints: "Jumlah Titik Poligon",
    viewGeolocation: "Lihat Geolokasi",
    geoLocation: "Geolokasi",
    Point: "Titik",
    Circular: "Lingkaran",
    Polygon: "Poligon",
    loadingProductionPlaces: "Memuat Tempat Produksi",
    remove: "Hapus",
    restore: "Pulihkan",
    riskMitigation: "Mitigasi Risiko",
    riskMitigationHistory: "Riwayat Mitigasi Risiko",
    riskMitigationDocument: "Dokumen Mitigasi Risiko",
    viewFarm: "Lihat Pertanian",
    farmReportNotAvailable: "Laporan pertanian tidak tersedia",
    signedBy: "Ditandatangani Secara Digital Oleh:",
    signParticipationSurvey:
      "Maukah Anda menandatangani secara digital untuk mengonfirmasi partisipasi Anda dalam survei ini?",
    assessmentRiskMitigation: "Mitigasi Risiko Penilaian",
    submissionDate: "Tanggal Pengiriman",
    eudrReferenceNo: "Nomor Referensi EUDR",
    internalReferenceNo: "Nomor Referensi Internal",
    exporter: "Eksportir",
    exporterInfo:
      "Nama Eksportir. Entitas atau pihak yang bertanggung jawab untuk mengekspor barang.",
    importer: "Importir",
    importerInfo: "Nama Importir. Entitas atau pihak yang bertanggung jawab untuk mengimpor barang.",
    shipmentReferenceNoInfo: "Pengidentifikasi unik yang digunakan untuk merujuk pada pengiriman.",
    ownerShipTypeInfo: "Jenis kepemilikan yang terkait dengan pengiriman.",
    shipmentReferenceNo: "Nomor Referensi Pengiriman",
    ownerShipType: "Tipe Kepemilikan",
    buyer: "Pembeli",
    buyerName: "Nama Pembeli",
    port_of_origin: "Pelabuhan Asal",
    port_of_origin_info: "Lokasi di mana pengiriman berasal.",
    port_of_destination: "Pelabuhan Tujuan",
    port_of_destination_info:
      "Pelabuhan tujuan yang dimaksud untuk pengiriman.",
    no_of_stops: "Jumlah Pemberhentian",
    shipping_line: "Jalur Pengiriman",
    shipping_line_info:
      "Perusahaan atau entitas yang bertanggung jawab untuk mengangkut pengiriman.",
    expected_arrival_date: "Tanggal Kedatangan yang Diharapkan",
    expected_arrival_date_info:
      "Tanggal perkiraan kedatangan pengiriman di tujuannya.",
    container_id: "ID Kontainer",
    container_id_info:
      "Pengidentifikasi unik untuk kontainer pengiriman yang digunakan dalam pengiriman.",
    container_type: "Tipe Kontainer",
    container_type_info: "Jenis atau kategori kontainer pengiriman.",
    container_size: "Ukuran Kontainer (ft)",
    container_size_info: "Dimensi fisik dari kontainer pengiriman.",
    container_capacity: "Kapasitas Kontainer (Ton)",
    container_capacity_info:
      "Muatan maksimum atau kapasitas kontainer pengiriman.",
    eudr_reference_number: "Nomor Referensi EUDR",
    dueDiligence: "Uji Tuntas EUDR",
    assementBuilder: "Pembuat Penilaian",
    assessment: "Penilaian",
    assessmentsList: "Daftar Penilaian",
    createAssessment: "Buat Penilaian",
    assessmentName: "Nama Penilaian",
    assessmentNameInfo: "Fungsi untuk menemukan penilaian atau informasi spesifik.",
    searchAssessment: "Cari Penilaian",
    selectProcess: "Pilih Proses Penilaian",
    assessSettings: "Pengaturan Penilaian",
    assessmentTitle: "Judul Penilaian",
    assessDescription: "Deskripsi Penilaian",
    describeAsessment: "Deskripsikan Penilaian",
    selectCountry: "Pilih Negara",
    expiryTime: "Waktu Kedaluwarsa",
    noQuestionEachStep: "Jumlah Pertanyaan",
    byHeadings: "Menurut Judul",
    assessmentStatus: "Status Penilaian",
    multiStepAssess: "Penilaian Multi Langkah",
    allowAssessment: "Izinkan penilaian dijawab lebih dari sekali",
    onlyIfExpired: "Hanya jika Kedaluwarsa",
    atAnyTime: "Kapan Saja",
    editAssessmentDetails: "Edit Pertanyaan Penilaian",
    assessmentDetail: "Detail Penilaian",
    addQuestion: "Tambah Pertanyaan Penilaian",
    attachFiles: "Lampirkan Berkas",
    digitalSignature: "Tanda Tangan Digital",
    showChecklist: "Tampilkan Daftar Periksa",
    hideChecklist: "Sembunyikan Daftar Periksa",
    fileType: "Tipe Berkas",
    allowMultipleFile: "Izinkan Lampiran Ganda",
    allowComment: "Izinkan Komentar",
    uploadSignatureFile: "Unggah Berkas Tanda Tangan",
    drawSignature: "Gambar Tanda Tangan",
    addSubHeading: "Tambah Sub-judul",
    heading: "Judul",
    subHeading: "Sub-judul",
    dueDiligenceReports: "Laporan Uji Tuntas",
    manageFarms: "Kelola Lahan",
    suppliers: "Pemasok",
    shipments: "Pengiriman",
    dueDiligenceGuide: "Panduan Uji Tuntas",
    selectRequiredAssessment: "Pilih Penilaian yang Dibutuhkan",
    filterAssessments: "Saring Penilaian",
    dueDiligenceReportCreation: "Pembuatan Laporan Uji Tuntas",
    dueDiligenceNew: "Uji Tuntas",
    createNewReport: "Buat Laporan Baru",
    operator: "Operator",
    supplier: "Pemasok",
    addMoreAssessments: "Tambahkan Penilaian Lagi",
    internalReferenceNumber: "Nomor Referensi Internal",
    referenceNumber: "Nomor Referensi",
    domestic: "Domestik",
    import: "Impor",
    export: "Ekspor",
    selectProduct: "Pilih Produk",
    selectSubProduct: "Pilih Sub Produk",
    addnewSupplier: "Tambah Pemasok Baru",
    farmDeforestationReport: "Laporan Deforestasi Lahan",
    addProductionPlaceData: "Tambahkan Data Tempat Produksi",
    addProductionPlaceDataTooltip:
      "Pilih bagaimana Anda ingin menambahkan data",
    addProductionPlaceDataDesc:
      "Buat laporan Anda dengan mengintegrasikan data produksi dari berbagai sumber. Pilih satu atau beberapa sumber untuk menyusun daftar lengkap tempat produksi untuk laporan Anda.",
    dimitraApps: "Aplikasi Dimitra",
    addNew: "Tambah Baru",
    existingData: "Data yang Ada",
    manualDataEntry: "Entri Data Manual",
    importFile: "Impor File",
    connectedCoffee: "Kopi Terhubung",
    connectedCacao: "Kakao Terhubung",
    connectedFarmer: "Petani Terhubung",
    manaulProductionPlace: "Entri Data Tempat Produksi Manual",
    addProductionPlace: "Tambahkan Tempat Produksi",
    producerCountry: "Negara Produsen",
    totalArea: "Luas Total",
    number: "Nomor",
    productionPlaceDesc: "Deskripsi Tempat Produksi",
    type: "Tipe",
    actions: "Aksi",
    selectType: "Pilih Tipe",
    importProductionPlace: "Impor Tempat Produksi",
    downloadCSVFormat: "Unduh Format CSV",
    downloadXLSFormat: "Unduh Format XLS",
    downloadGeoJsonFormat: "Unduh Format GeoJSON",
    downloadXMLFormat: "Unduh Format XML",
    downloadFileFormatTemplates: "Unduh Template Format File",
    importantNote: "Catatan Penting",
    pleaseProvideFollowing: "Silakan berikan format berikut (GeoJSON dan XML)",
    existingProductionPlaces: "Tempat Produksi yang Ada",
    productionPlaceAndFarmID: "Tempat Produksi & ID Perkebunan",
    selectFileToUploadData: "Pilih file untuk mengunggah data",
    filterByDate: "Filter Berdasarkan Tanggal",
    dateOfRegister: "Tanggal Pendaftaran",
    dateOfLastReport: "Tanggal Laporan Terakhir",
    clearAll: "Hapus Semua",
    addLocation: "Tambah Lokasi",
    pleaseCompleteBeforeProceedingToNext:
      "Harap selesaikan bagian detail laporan sebelum melanjutkan ke langkah berikutnya.",
    progressSavedSuccessMsg: "Kemajuan berhasil disimpan!",
    failedSavedProgress: "Gagal menyimpan kemajuan. Silakan coba lagi.",
    failedToCreateReportDetails:
      "Gagal membuat ReportDetails. Silakan coba lagi.",
    unExpectedErrorMsg:
      "Terjadi kesalahan yang tidak terduga. Silakan coba lagi.",
    selectAssessment: "Pilih Penilaian",
    confirmationPopup: "Popup Konfirmasi",
    confirmationPopupMsg:
      "Apakah Anda yakin ingin membuang laporan ini? Mengkonfirmasi tindakan ini akan mengakibatkan penghapusan permanen.",
    warningPopup: "Popup Peringatan",
    warningPopupMsg:
      "Apakah Anda yakin ingin menolak laporan ini? Harap dicatat: Data laporan ini akan disimpan setelah penolakan jika Anda ingin meninjaunya nanti.",
    automatedDeforestationProgressText:
      "Pemeriksaan deforestasi otomatis dari data geofence dan identifikasi kasus kritis",
    someRiskWereIdentifiedText:
      "Harap tinjau penilaian risiko deforestasi tempat produksi berikut dan lakukan mitigasi sebelum melanjutkan.",
    riskAssessmentAndMitigation: "Penilaian dan Mitigasi Risiko",
    riskAssessmentStatus: "Status Penilaian Risiko",
    riskAssessment: "Penilaian Risiko",
    uploadRiskAssessment: "Unggah Penilaian Risiko",
    manualFillOutAssessment: "Isi penilaian secara manual",
    manualFillOutAssessmentTT:
      "Tindakan untuk menyelesaikan formulir penilaian secara manual.",
    criteria: "Kriteria (b, f dan g)",
    downloadAssessmentForm: "Unduh Formulir Penilaian",
    addSignature: "Tambahkan Tanda Tangan",
    uploadImage: "Unggah Gambar",
    createNewDueDiligenceProgress: "Buat Proses Due Diligence Baru",
    usageLimits: "Batasan Penggunaan",
    totalReports: "Total Laporan",
    eudrDeforestationAssessments: "Penilaian Deforestasi EUDR",
    totalAssessments: "Total Penilaian",
    listOfFarms: "Daftar Pertanian",
    perMonth: "Per Bulan",
    share: "Bagikan",
    viewReport: "Lihat Laporan",
    listOfSupplier: "Daftar Pemasok",
    addNewSupplier: "Tambahkan pemasok baru",
    editSupplier: "Edit Pemasok",
    supplierName: "Nama Pemasok",
    listOfOperators: "Daftar Operator",
    addNewOperator: "Tambahkan Operator Baru",
    operatorName: "Nama Operator",
    operators: "Operator",
    editOperator: "Edit Operator",
    eoriNumber: "Nomor EORI",
    enterEmailAddress: "Masukkan alamat email",
    enterFirstName: "Masukkan nama depan",
    enterLastName: "Masukkan nama belakang",
    enterEORINumber: "Masukkan Nomor EORI",
    myFarms: "Ladang Saya",
    listOfProducers: "Daftar Produsen",
    producers: "Produsen",
    addNewProducer: "Tambahkan Produsen Baru",
    lastAssessment: "Penilaian Terakhir",
    shipmentID: "ID Pengiriman",
    noOfReports: "Jumlah Laporan",
    operatorSelect:
      "Operator: Pilih opsi ini jika Anda, sebagai operator, akan bertanggung jawab untuk menambahkan data tempat produksi. Anda akan memiliki opsi untuk memberikan daftar produsen, ladang mereka, dan geolokasi dalam aplikasi.",
    supplierSelect:
      "Pemasok: Pilih opsi ini jika pemasok yang akan bertanggung jawab untuk menambahkan data tempat produksi. Mereka akan memiliki akses untuk memberikan daftar produsen, ladang mereka, dan geolokasi langsung dalam aplikasi.",
    selectWhoWillAddPlaceData:
      "Pilih siapa yang akan menambahkan Data Tempat Produksi",
    selectUsers: "Pilih Pengguna",
    mutiStepHeadingLable: "Buat langkah baru untuk setiap Sub-Judul",
    logistics: "Logistik",
    editSubHeading: "Edit Sub-Judul",
    headingTitle: "Judul Utama",
    partOfOrigin: "Bagian Asal",
    destination: "Tujuan",
    addStop: "Tambahkan Pemberhentian",
    stop: "Pemberhentian",
    enterStop: "Masukkan Pemberhentian",
    createShipment: "Buat Pengiriman Baru",
    disputeAssessment: "Penilaian Sengketa",
    multiStepQuestion1: "Buat Langkah Baru setelah",
    questions: "pertanyaan",
    confirmation: "Konfirmasi",
    saveAndConfirmationMessage: "Apakah Anda yakin ingin menyimpan perubahan?",
    supplierNotRegisterContent:
      "Pemasok belum terdaftar. Apakah Anda ingin mengirim pemberitahuan ke pemasok untuk bergabung dengan platform melalui email?",

    processingDialog: {
        modalHeader: "Menganalisis Status Deforestasi",
        modalDescription_first: "Menganalisis Status Deforestasi EUDR",
        modalDescription_second: "Lahan pertanian Anda sedang menjalani Analisis Deforestasi Otomatis. Anda akan diarahkan ke halaman daftar Laporan Uji Tuntas untuk melihat statusnya.",
    },
    

    farmList: {
      title: "Daftar Perkebunan EUDR",
      addFarmGeofenceManually: "Tambahkan geofence perkebunan secara manual",
      importGeofenceInBulk: "IMPOR GEOCENCE DALAM JUMLAH BESAR",
      searchPlaceHolder: "Cari berdasarkan nama petani",
      generateCertificate: "Hasilkan Sertifikat",
      requestAssementReport: "Minta Laporan Penilaian",
      producer: "Produser",
      farmNameAndId: "Nama & ID Perkebunan",
      addressOfProduction: "Alamat Produksi",
      registrationDate: "Tanggal Registrasi",
      eudrDeforestationStatus: "Status Deforestasi EUDR",
      riskAssessmentStatus: "Status Penilaian Risiko",
      assessmentTitle: "Judul Penilaian",
      assessmentDescription: "Deskripsi Penilaian",
      submissionDate: "Tanggal Pengiriman",
      expiryDate: "Tanggal Kedaluwarsa",
      assessmentStatus: "Status Penilaian",
      downloadAsKmx: "Unduh sebagai KMX",
      downloadAsKml: "Unduh sebagai KML",
      downloadAsShp: "Unduh sebagai SHP",
      downloadAsCsv: "Unduh sebagai CSV",
      downloadAsExcel: "Unduh sebagai EXCEL",
      downloadAsPdf: "Unduh sebagai PDF",
      downloadAsGeoJson: "Unduh sebagai GeoJSON",
      loadingFarms: "Memuat perkebunan",
    },
    dueDeligenceReport: "Konfigurasi Laporan Uji Tuntas Publik",
    allowPublicDownload:
      "Izinkan unduhan publik geofence pertanian dalam format GeoJson",
    showDeforestationSummary:
      "Tampilkan Ringkasan Risiko Deforestasi EUDR berdasarkan kategori",
    cancel: "Batalkan",

    deforestationAssessmentRiskToleranceLevel:
      "Tingkat Toleransi Risiko Penilaian Deforestasi",
    deforestationAssessmentRiskToleranceLevelInfo:
      "Gunakan alat ini untuk mengonfigurasi berapa % deforestasi, untuk setiap peringkat, yang dapat diterima dalam proses Penilaian Risiko Anda. Perkebunan dengan risiko kurang dari atau sama dengan yang ditentukan akan dianggap layak untuk tetap berada di DDS, tanpa perlu melakukan Mitigasi Risiko.",
    showing_all: "Menampilkan Semua",
    declaration_title: "Judul Deklarasi",
    applicable_countries: "Negara yang Berlaku",
    enabled: "Diaktifkan",
    disabled: "Dinonaktifkan",
    add_more: "Buyer Lagi",
    mark_as_default: "Tandai sebagai Default",
    print: "Cetak",
    download: "Unduh",
    loading: "Memuat...",
    tons: "Ton",

    failedToDeleteQuestion: "Gagal menghapus pertanyaan",
    questionTypeNotDefined: "Jenis pertanyaan belum ditentukan",
    questionOrderSuccessfullyUpdated: "Urutan pertanyaan berhasil diperbarui",
    assessmentUpdatedSuccessfully: "Penilaian berhasil diperbarui",
    pleaseWaitCurrentlyUpdatingChecklist:
      "Harap tunggu, sedang memperbarui daftar periksa",

    assessmentDetails: "Detail Penilaian",
    dontShowWarning: "Jangan tampilkan peringatan ini lagi.",
    dateSubmitted: "Tanggal Dikirim",
    addAComment: "Tambahkan Komentar",
    changeAssignee: "Ubah Penanggung Jawab",
    changeStatus: "Ubah Status",
    assignedUser: "Pengguna yang Ditugaskan",
    selectAssignee: "Pilih Penanggung Jawab",
    reply: "Balas",
    discussion: "Diskusi",
    attachment: "Lampiran",
    sizeKb: "Ukuran (KB)",
    dateAdded: "Tanggal Ditambahkan",

    shipmentStatus: "Status Pengiriman",
    viewStops: "Lihat Pemberhentian",
    enRoute: "Dalam Perjalanan",
    delivered: "Terkirim",
    failed: "Gagal",
    removeEudrDeforestationStatus: "Hapus Status Deforestasi EUDR",
    riskAssessmentStatusIsRequired: "Status penilaian risiko diperlukan",
    requestAdditionalInformationPage: {
      descriptionLabel: "Harap berikan komentar atau instruksi spesifik di kotak teks di bawah ini. Setelah dikirim, pemasok akan diberi tahu dan diberikan akses untuk mengedit laporan due diligence. Anda akan diberi tahu ketika pemasok memperbarui laporan.",
      shareAccessLabel: "Pemasok saat ini tidak memiliki akses ke laporan ini. Apakah Anda ingin membagikan akses dengan pemasok? Silakan pilih bagaimana Anda ingin berbagi akses:",
      shareCompleteReportLabel: "Bagikan laporan lengkap",
      shareSpecificStepLabel: "Bagikan langkah tertentu"
    },
    issueFound: "Masalah Ditemukan",
    complianceRiskWarningsTT: "Pemberitahuan Peringatan Risiko memberi tahu Anda tentang potensi masalah kepatuhan di setiap langkah proses due diligence. Pemberitahuan ini membantu memastikan bahwa semua risiko teridentifikasi sebelum melanjutkan ke tahap berikutnya. Anda dapat mengaktifkan atau menonaktifkan peringatan ini kapan saja di Pengaturan Laporan atau selama pembuatan laporan.",
    registered: "Terdaftar",
    conclude: "Menyimpulkan",
    circularGeofenceWithAreaGreaterThan4HA: "Geofence melingkar dengan luas lebih dari 4 Ha",
    statusLegend: "Legenda Status",
    statusLegendInfo: "Legenda status memberikan gambaran cepat tentang status terkini dari laporan uji tuntas. Ini digunakan untuk menunjukkan status laporan saat ini dan tindakan yang dapat diambil untuk memperbarui laporan.",
    sentToExporter: "Dikirim ke Eksportir",
    pendingOrNewlyReceived: "Tertunda/Baru Diterima",
    approved: "Disetujui / Di Blockchain",
    updateRequired: "Perlu Diperbarui",
    rejected: "Ditolak",
    noExporterFound: "Tidak ditemukan eksportir",
    exporterFoundSuccessfully: "Eksportir berhasil ditemukan",
    exporterAlreadyAdded: "Eksportir ini sudah ditambahkan",
    addExporter: "Tambah Eksportir",
    addedExporters: "Eksportir yang Ditambahkan",
    exporterMandatoryNote: "(Minimal satu eksportir wajib diisi)",
    removeExporter: "Hapus eksportir",
    enterExporterEmail: "Masukkan Email Eksportir",
    shareReport: "Bagikan Laporan ke Eksportir",
    exporterInformation: "Informasi Eksportir",
    pleaseEnterExporterEmail: "Silakan masukkan email eksportir",

    // Activity Log translations
    activityLog: "Log Aktivitas",
    activityLogTT: "Catatan tindakan yang dilakukan pada laporan ini.",
    user: "Pengguna",
    userRole: "Peran Pengguna",
    ipAddress: "Alamat IP",
    segment: "Segmen",
    activityDescription: "Deskripsi Aktivitas",
    statusHistory: "Riwayat Status",
    viewStatusHistory: "Lihat Riwayat Status",
    dateTime: "Tanggal & Waktu",
    expiresOn: "Berlaku hingga",
    failedToLoadHistory: "Gagal memuat riwayat status",
    productionPlaceIdNotFound: "ID tempat produksi tidak ditemukan",
    noHistoryFound: "Tidak ada riwayat ditemukan",

    overdue: "Terlambat",
    waitingForPayment: "Menunggu Pembayaran",
    paymentPendingVerificationStatus: "Pembayaran Menunggu Verifikasi",
    approvalStatus: "Status Persetujuan",
    pendingApproval: "Tertunda",
    temporaryApproved: "Proses Penyetujuan",
    exporterInformationKenya:"Informasi Eksportir / Agent",
    selectUserToAssign: "Pilih Pengguna untuk Dialokasikan",
    shipmentInProcess: "Pengiriman Dalam Proses",

  },
  dueDiligence: {
    doYouWantToSendToOperator: "Apakah Anda ingin mengirim laporan ini ke operator?",
    downloadQrCode: "Unduh Kode QR",
        farmerRegistrationId: "ID Registrasi Petani",
farmRegistrationId: "ID Registrasi Perkebunan",
    comments: "Komentar",
    attachRiskMitigationDocumentForAllNonCompliantFarms: "Lampirkan Dokumen Mitigasi Risiko untuk Semua Pertanian yang Tidak Mematuhi",
    attachOneRiskMitigationDocumentForAllNonCompliantFarms: "LAMPIRKAN SATU DOKUMEN MITIGASI RISIKO UNTUK SEMUA PERTANIAN YANG TIDAK MEMATUHI",
    fileRequired: "File wajib diisi",
    errorMitigatingFarms: "Kesalahan dalam mitigasi pertanian",
    submit: "Kirim",
    commentsRegardingStatement:"komentar mengenai pernyataan",
    maxCharacterLimit: "Maksimum {max} karakter diizinkan",
    countryOfProduction: "Negara Produksi",
    countryOfProductionTT: "Negara Produksi",
    containerId:"Id Kontainer",
    createWithoutRiskAssessment: {
      title: "Buat DDS Tanpa Penilaian Risiko",
      message: "Apakah Anda ingin membuat DDS tanpa menambahkan Penilaian Risiko? Jika ya, aturan pemeriksaan keluhan akan melewati langkah ini.",
      confirmBtnText: "Ya",
      cancelBtnText: "Tidak",
      doNotShowAgain: "Jangan tampilkan pesan ini lagi"
    },
    noAssessmentWarning: "Laporan DDS tidak memiliki penilaian risiko.",
    disputeReason: "Silakan pilih alasan perselisihan.",
    agricultureAgreement: "Silakan setujui ketentuan sebelum melanjutkan.",
    attachDisputeFile:
      "Silakan lampirkan file sebelum mengajukan perselisihan.",
    listOfFarmsInfo:
      "Tampilan pertanian yang komprehensif, termasuk informasi seperti lokasi produksi, nama produsen, negara operasi, luas lahan dalam hektar, jenis kegiatan pertanian, penilaian terkait deforestasi, dan evaluasi potensi risiko yang terkait dengan operasi pertanian.",
    producerTT:
      "Pemilihan produsen atau pembuat yang terlibat dalam rantai pasokan.",
    supplierInformationTT:
      "Rincian tentang entitas yang menyediakan barang atau jasa.",
    operatorTooltip:
      "Pilih Operator dari daftar yang sudah terdaftar di sistem",
    supplierTooltip:
      "Pilih pemasok dari daftar yang telah terdaftar sebelumnya di sistem.",
    requiredAssessmentTooltip: "Pilih informasi penilaian yang diperlukan.",
    internalRefNoTooltip:
      "Pengidentifikasi unik yang ditetapkan dalam suatu organisasi atau sistem untuk merujuk pada data, transaksi, atau catatan tertentu untuk tujuan pelacakan dan pengelolaan internal.",
    eudrRefNoTooltip:
      "Mengacu pada pengidentifikasi unik yang terkait dengan Regulasi Penggundulan Hutan Uni Eropa (EUDR), biasanya digunakan untuk melacak dan merujuk informasi terkait kepatuhan dalam konteks regulasi penggundulan hutan.",
    companyIdTooltip:
      "Pengidentifikasi yang berbeda yang diberikan kepada perusahaan atau organisasi untuk tujuan identifikasi dan pelacakan, sering digunakan dalam sistem, basis data, atau kerangka peraturan.",
    placeOfActivityTooltip: "Tentukan negara operator tempat aktivitas dilakukan dan negara tempat produk akan memasuki pasar UE. Detail ini penting untuk kepatuhan yang akurat dengan persyaratan EUDR.",
    productDetailToolTip:
      "Memberikan informasi rinci tentang produk, termasuk nama, massa bersih, volume, nama ilmiah, dan nama umum.",
    productToolTip:
      "Nama Produk. Mengacu pada item atau barang berwujud yang diproduksi, dibuat, atau diperdagangkan oleh perusahaan.",
    productDescToolTip:
      "Memberikan penjelasan atau ringkasan tekstual tentang karakteristik, fungsi, atau atribut suatu produk, dengan tujuan untuk menginformasikan pengguna atau pelanggan tentang sifat atau fungsinya.",
    subProductToolTip:
      "Nama Sub-produk. Menunjukkan kategori atau sub-kategori spesifik dari kategori produk yang lebih besar, biasanya digunakan untuk klasifikasi atau diferensiasi tambahan dalam hierarki produk.",
    netMassTooltTip:
      "Menunjukkan berat suatu produk atau item, biasanya tidak termasuk berat kemasan atau bahan lainnya.",
    estimatedDdsFeeAmount: "Perkiraan biaya peninjauan DDS: {currency} {amount}",
    pricePerTonNote: "{currency} {pricePerTon} per ton",
    volumeToolTip:
      "Mengacu pada jumlah ruang yang ditempati oleh produk atau zat, biasanya diukur dalam satuan kubik seperti meter kubik atau kaki kubik, digunakan untuk mengukur kapasitas atau jumlah dalam ruang tiga dimensi.",
    scientificNameToolTip:
      "Nama taksonomi dari suatu organisme yang terdiri dari genus dan spesies, misalnya, Coffea Arabica, Theobroma cacao L.",
    commonNameToolTip:
      "Nama berdasarkan bahasa sehari-hari, misalnya, Kakao, Kopi.",
    manualProductionPlaceTooltip:
      "Proses memasukkan lokasi pabrik secara manual ke dalam sistem.",
    producerNameTT:
      "Nama individu/perusahaan/organisasi yang menciptakan dan menyediakan barang atau jasa.",
    producerCountryTT: "Negara asal dari produsen.",
    dueDiligence: "Uji Tuntas EUDR",
    assementBuilder: "Pembuat Penilaian",
    assessment: "Penilaian",
    assessmentsList: "Daftar Penilaian",
    createAssessment: "Buat Penilaian",
    assessmentName: "Nama Penilaian",
    searchAssessment: "Cari Penilaian",
    selectProcess: "Pilih Proses Penilaian",
    assessSettings: "Pengaturan Penilaian",
    assessmentTitle: "Judul Penilaian",
    assessmentTitleInfo: "Nama yang mengidentifikasi penilaian.",
    assessDescription: "Deskripsi Penilaian",
    assessDescriptionInfo:
      "Penjelasan singkat tentang tujuan atau isi penilaian.",
    describeAsessment: "Deskripsikan Penilaian",
    selectCountry: "Pilih Negara",
    expiryTime: "Waktu Kedaluwarsa",
    expiryTimeInfo:
      "Durasi hingga penilaian kedaluwarsa atau menjadi tidak berlaku.",
    noQuestionEachStep: "Jumlah Pertanyaan",
    byHeadings: "Menurut Judul",
    assessmentStatus: "Status Penilaian",
    multiStepAssess: "Penilaian Multi Langkah",
    allowAssessment: "Izinkan penilaian dijawab lebih dari sekali",
    onlyIfExpired: "Hanya jika Kedaluwarsa",
    atAnyTime: "Kapan Saja",
    editAssessmentDetails: "Edit Pertanyaan Penilaian",
    assessmentDetail: "Detail Penilaian",
    addQuestion: "Tambah Pertanyaan Penilaian",
    attachFiles: "Lampirkan Berkas",
    digitalSignature: "Tanda Tangan Digital",
    showChecklist: "Tampilkan Daftar Periksa",
    hideChecklist: "Sembunyikan Daftar Periksa",
    fileType: "Tipe Berkas",
    allowMultipleFile: "Izinkan Lampiran Ganda",
    allowComment: "Izinkan Komentar",
    uploadSignatureFile: "Unggah Berkas Tanda Tangan",
    drawSignature: "Gambar Tanda Tangan",
    addSubHeading: "Tambah Sub-judul",
    heading: "Judul",
    headingInfo:
      "Judul di mana pertanyaan penilaian akan dikategorikan. Menu dropdown untuk memilih judul.",
    subHeading: "Sub-judul",
    dueDiligenceReports: "Laporan Uji Tuntas",
    manageFarms: "Kelola Lahan",
    disputeResolution: "Penyelesaian Sengketa",
    suppliers: "Pemasok",
    shipments: "Pengiriman",
    dueDiligenceGuide: "Panduan Uji Tuntas",
    selectRequiredAssessment: "Pilih Penilaian yang Dibutuhkan",
    filterAssessments: "Saring Penilaian",
    dueDiligenceReportCreation: "Pembuatan Laporan Uji Tuntas",
    dueDiligenceNew: "Uji Tuntas",
    createNewReport: "Buat Laporan Baru",
    operator: "Operator",
    supplier: "Pemasok",
    addMoreAssessments: "Tambahkan Penilaian Lagi",
    internalReferenceNumber: "Nomor Referensi Internal",
    referenceNumber: "Nomor Referensi",
    domestic: "Domestik",
    import: "Impor",
    export: "Ekspor",
    selectProduct: "Pilih Produk",
    selectSubProduct: "Pilih Sub Produk",
    addnewSupplier: "Tambah Pemasok Baru",
    farmDeforestationReport: "Laporan Deforestasi Lahan",
    addProductionPlaceData: "Tambahkan Data Tempat Produksi",
    addProductionPlaceDataTooltip:
      "Pilih bagaimana Anda ingin menambahkan data",
    addProductionPlaceDataDesc:
      "Buat laporan Anda dengan mengintegrasikan data produksi dari berbagai sumber. Pilih satu atau beberapa sumber untuk menyusun daftar lengkap tempat produksi untuk laporan Anda.",
    dimitraApps: "Aplikasi Dimitra",
    addNew: "Tambah Baru",
    existingData: "Data yang Ada",
    manualDataEntry: "Entri Data Manual",
    importFile: "Impor File",
    connectedCoffee: "Kopi Terhubung",
    connectedCacao: "Kakao Terhubung",
    manaulProductionPlace: "Entri Data Tempat Produksi Manual",
    manaulProductionPlaceTooltip:
      "Proses memasukkan lokasi pabrik secara manual ke dalam sistem.",
    addProductionPlace: "Tambahkan Tempat Produksi",
    producerName: "Nama Produsen",
    producerCountry: "Negara Produsen",
    totalArea: "Luas Total",
    number: "Nomor",
    productionPlaceDesc: "Deskripsi Tempat Produksi",
    area: "Area (ha)",
    type: "Tipe",
    actions: "Aksi",
    selectType: "Pilih Tipe",
    importProductionPlace: "Impor Tempat Produksi",
    downloadXLSFormat: "Unduh Format XLS",
    downloadGeoJsonFormat: "Unduh Format GeoJSON",
    downloadXMLFormat: "Unduh Format XML",
    downloadFileFormatTemplates: "Unduh Template Format File",
    importantNote: "Catatan Penting",
    pleaseProvideFollowing: "Silakan berikan format berikut (GeoJSON dan XML)",
    existingProductionPlaces: "Tempat Produksi yang Ada",
    productionPlaceAndFarmID: "Tempat Produksi & ID Perkebunan",
    selectFileToUploadData: "Pilih file untuk mengunggah data",
    filterByDate: "Filter Berdasarkan Tanggal",
    dateOfRegister: "Tanggal Pendaftaran",
    dateOfLastReport: "Tanggal Laporan Terakhir",
    clearAll: "Hapus Semua",
    addLocation: "Tambah Lokasi",
    pleaseCompleteBeforeProceedingToNext:
      "Harap selesaikan bagian detail laporan sebelum melanjutkan ke langkah berikutnya.",
    progressSavedSuccessMsg: "Kemajuan berhasil disimpan!",
    failedSavedProgress: "Gagal menyimpan kemajuan. Silakan coba lagi.",
    failedToCreateReportDetails:
      "Gagal membuat ReportDetails. Silakan coba lagi.",
    unExpectedErrorMsg:
      "Terjadi kesalahan yang tidak terduga. Silakan coba lagi.",
    selectAssessment: "Pilih Penilaian",
    confirmationPopup: "Popup Konfirmasi",
    confirmationPopupMsg:
      "Apakah Anda yakin ingin membuang laporan ini? Mengkonfirmasi tindakan ini akan mengakibatkan penghapusan permanen.",
    warningPopup: "Popup Peringatan",
    warningPopupMsg:
      "Apakah Anda yakin ingin menolak laporan ini? Harap dicatat: Data laporan ini akan disimpan setelah penolakan jika Anda ingin meninjaunya nanti.",
    automatedDeforestationProgressText:
      "Pemeriksaan deforestasi otomatis dari data geofence dan identifikasi kasus kritis",
    someRiskWereIdentifiedText:
      "Harap tinjau penilaian risiko deforestasi tempat produksi berikut dan lakukan mitigasi sebelum melanjutkan.",
    reviewProductionPlaceRiskAdvisory:
      "Harap tinjau penilaian risiko deforestasi tempat produksi berikut dan lakukan mitigasi sebelum melanjutkan.",
    riskAdvisoryMitigationRecommended: "Peringatan Risiko — Mitigasi Direkomendasikan",
    riskAdvisoryMitigationRecommendedBody:
      "{count} perkebunan telah ditandai dengan risiko yang dapat menyebabkan keterlambatan selama persetujuan. Dokumentasi mitigasi tidak wajib tetapi sangat direkomendasikan sebelum pengajuan.",
    riskAdvisoryMitigationRequired: "Peringatan Risiko — Mitigasi Diperlukan",
    riskAdvisoryMitigationRequiredBody:
      "{count} perkebunan memiliki temuan risiko tinggi yang harus diselesaikan sebelum DDS ini dapat diajukan. Anda tidak dapat melanjutkan hingga dokumentasi mitigasi diunggah untuk semua perkebunan berisiko tinggi.",
    uploadMitigationDocumentationRecommended: "Unggah Dokumentasi Mitigasi (Direkomendasikan)",
    uploadMitigationDocumentation: "Unggah Dokumentasi Mitigasi",
    requestToUploadMitigation: "Minta untuk Mengunggah",
    requestAdditionalInformationBatchHint:
      "Mengirim permintaan ini akan memberi tahu koperasi sekali dengan semua {count} tempat produksi yang antre tercantum di bawah.",
    requestAdditionalInformationBatchEmptyHint:
      "Anda dapat mengantre perkebunan individual menggunakan Minta untuk Mengunggah atau Minta Revisi, lalu kirim satu notifikasi terakumulasi dari sini.",
    supplierNotFoundForRequest:
      "Tidak dapat menemukan pemasok untuk laporan ini. Harap segarkan halaman dan coba lagi.",
    farmsPendingRevisionBatch: "Tempat Produksi Antre untuk Pembaruan",
    farmsPendingRevisionBatchHint:
      "Perkebunan ini diantre dari tindakan tinjauan individual. Satu email dan notifikasi gabungan akan dikirim saat Anda mengirimkan.",
    revisionRequired: "Revisi Diperlukan",
    uploadRequired: "Unggahan Diperlukan",
    attachReferenceDocuments: "Lampirkan Dokumen Referensi",
    attachReferenceDocumentsHint: "Opsional. Unggah dokumen pendukung atau templat untuk ditinjau pemasok saat mengirimkan bukti mitigasi.",
    selectDocumentsToAttach: "Pilih dokumen untuk dilampirkan",
    attachedDocuments: "Dokumen Terlampir",
    approveMitigationWithoutDocumentsNote:
      "Satu atau lebih perkebunan yang dipilih tidak memiliki dokumen mitigasi yang diunggah. Anda masih dapat menyetujuinya dengan status mitigasi sementara.",
    approveMitigationWithoutDocumentsPermanentNote:
      "Satu atau lebih perkebunan yang dipilih tidak memiliki dokumen mitigasi yang diunggah. Mereka akan ditandai secara permanen sebagai Mitigasi Manual.",
    approveMitigationEvidenceTitle: "Setujui Bukti Mitigasi",
    approveMitigationEvidenceButton: "Setujui Bukti",
    approveMitigationEvidenceIntroSingle: "Setujui bukti untuk {name}.",
    approveMitigationEvidenceIntroBulk: "Setujui bukti untuk {count} perkebunan.",
    approveMitigationEvidencePermanentSummary:
      "Perkebunan akan ditandai secara permanen sebagai Mitigasi Manual.",
    approveMitigationEvidenceTemporarySummary:
      "Perkebunan akan ditandai sebagai Mitigasi Manual untuk periode yang dipilih, lalu kembali ke status risiko aslinya.",
    approveMitigationEvidenceRevertNote:
      "Setelah periode ini, setiap perkebunan kembali ke status kepatuhan sebelumnya (mis. Risiko Sedang).",
    approveMitigationNoDocumentsWarningTitle: "Dokumen mitigasi tidak ada",
    proceedWithoutMitigation: "Lanjutkan Tanpa Mitigasi",
    cancelAndCreateNewDds: "Batalkan dan Buat DDS Baru",
    legendMitigationRecommended: "Mitigasi Direkomendasikan",
    legendMitigationRequired: "Mitigasi Diperlukan",
    legendMitigationUploaded: "Mitigasi Diunggah",
    localDbAndEudrMitigationTitle: "Kepatuhan DB Lokal & Mitigasi Deforestasi EUDR",
    localDbAndEudrMitigationSubtitle:
      "Tinjau bukti pemasok untuk perkebunan berisiko sedang dan tinggi yang ditandai di bawah Kepatuhan DB Lokal dan Status Deforestasi EUDR",
    eudrAssessmentCannotProceedTitle: "Tidak Dapat Melanjutkan",
    eudrAssessmentRiskDetectedInPlaces:
      "Risiko terdeteksi di {count} tempat produksi | Risiko terdeteksi di {count} tempat produksi",
    eudrAssessmentCannotProceedSubtext:
      "Tempat produksi ini harus mencapai status Nol/Tidak Signifikan atau Mitigasi Manual sebelum Anda dapat melanjutkan ke langkah berikutnya.",
    eudrAssessmentCannotProceedHelperTitle: "Cara menyelesaikan perkebunan dengan risiko terdeteksi",
    eudrAssessmentCannotProceedStep1:
      "Temukan tempat produksi yang terpengaruh di tabel dan buka menu tindakan (ikon clipboard) di sebelah kanan.",
    eudrAssessmentCannotProceedStep2:
      "Pilih Mitigasi Risiko Manual dan unggah dokumen pendukung untuk tinjauan risiko Anda.",
    eudrAssessmentCannotProceedStep3:
      "Setelah mitigasi disetujui, status EUDR akan diperbarui menjadi Mitigasi Manual dan Anda dapat melanjutkan.",
    eudrAssessmentCannotProceedStep4:
      "Jika Anda tidak setuju dengan penilaian deforestasi, ajukan permintaan Sengketa dari menu tindakan yang sama.",
    eudrAssessmentCannotProceedTimelineNote:
      "Harap dicatat: Tinjauan Mitigasi Risiko Manual biasanya selesai dalam beberapa hari kerja. Penyelesaian sengketa dan penilaian ulang dapat memakan waktu beberapa hari hingga seminggu atau lebih, tergantung volume tinjauan. Anda akan diberi tahu setelah keputusan dibuat dan dapat melanjutkan setelah status diperbarui.",
    eudrAssessmentCannotProceedGoBack: "Kembali",
    productionPlacesCount: "tempat produksi",
    riskAssessmentAndMitigation: "Penilaian dan Mitigasi Risiko",
    riskAssessmentStatus: "Status Penilaian Risiko",
    riskAssessment: "Penilaian Risiko",
    uploadRiskAssessment: "Unggah Penilaian Risiko",
    uploadRiskAssessmentTT:
      "Tindakan untuk mengunggah dokumen penilaian risiko.",
    manualFillOutAssessment: "Isi penilaian secara manual",
    downloadAssessmentForm: "Unduh Formulir Penilaian",
    addSignature: "Tambahkan Tanda Tangan",
    createNewDueDiligenceProgress: "Buat Proses Due Diligence Baru",
    usageLimits: "Batasan Penggunaan",
    totalReports: "Total Laporan",
    eudrDeforestationAssessments: "Penilaian Deforestasi EUDR",
    totalAssessments: "Total Penilaian",
    listOfFarms: "Daftar Pertanian",
    perMonth: "Per Bulan",
    share: "Bagikan",
    viewReport: "Lihat Laporan",
    viewReportSummary: "Lihat Ringkasan Laporan",
    copy: "Salin",
    copyAndCreateNew: "Salin dan Buat Baru",
    listOfSupplier: "Daftar Pemasok",
    addNewSupplier: "Tambahkan pemasok baru",
    editSupplier: "Edit Pemasok",
    supplierName: "Nama Pemasok",
    listOfOperators: "Daftar Operator",
    addNewOperator: "Tambahkan Operator Baru",
    operatorName: "Nama Operator",
    operators: "Operator",
    editOperator: "Edit Operator",
    eoriNumber: "Nomor EORI",
    isoCode: "Kode ISO",
    enterEmailAddress: "Masukkan alamat email",
    enterFirstName: "Masukkan nama depan",
    enterLastName: "Masukkan nama belakang",
    enterEORINumber: "Masukkan Nomor EORI",
    myFarms: "Ladang Saya",
    listOfProducers: "Daftar Produsen",
    producers: "Produsen",
    addNewProducer: "Tambahkan Produsen Baru",
    lastAssessment: "Penilaian Terakhir",
    noOfFarms: "Jumlah Ladang",
    shipmentID: "ID Pengiriman",
    noOfReports: "Jumlah Laporan",
    operatorSelect:
      "Operator: Pilih opsi ini jika Anda, sebagai operator, akan bertanggung jawab untuk menambahkan data tempat produksi. Anda akan memiliki opsi untuk memberikan daftar produsen, ladang mereka, dan geolokasi dalam aplikasi.",
    supplierSelect:
      "Pemasok: Pilih opsi ini jika pemasok yang akan bertanggung jawab untuk menambahkan data tempat produksi. Mereka akan memiliki akses untuk memberikan daftar produsen, ladang mereka, dan geolokasi langsung dalam aplikasi.",
    selectWhoWillAddPlaceData:
      "Pilih siapa yang akan menambahkan Data Tempat Produksi",
    selectUsers: "Pilih Pengguna",
    country: "Negara",
    mutiStepHeadingLable: "Buat langkah baru untuk setiap Sub-Judul",
    logistics: "Logistik",
    editSubHeading: "Edit Sub-Judul",
    headingTitle: "Judul Utama",
    partOfOrigin: "Bagian Asal",
    destination: "Tujuan",
    addStop: "Tambahkan Pemberhentian",
    stop: "Pemberhentian",
    enterStop: "Masukkan Pemberhentian",
    shipmentList: "Daftar Pengiriman",
    createShipment: "Buat Pengiriman Baru",
    alreadyInShipment: "Sudah dalam Pengiriman",
    disputeAssessment: "Penilaian Sengketa",
    multiStepQuestion1: "Buat Langkah Baru setelah",
    questions: "pertanyaan",
    questionsInfo: "Jumlah pertanyaan di setiap tahap penilaian bertahap.",
    confirmation: "Konfirmasi",
    saveAndConfirmationMessage: "Apakah Anda yakin ingin menyimpan perubahan?",
    supplierNotRegisterContent:
      "Pemasok belum terdaftar. Apakah Anda ingin mengirim pemberitahuan ke pemasok untuk bergabung dengan platform melalui email?",
    downloadAsJSON: "Unduh sebagai JSON",
    downloadOptions: "Opsi Unduhan",
    supplierTT:
      "Pemilihan pemasok atau produsen yang terlibat dalam rantai pasokan.",
    pleaseSelectAtLeastOneItem: "Harap pilih setidaknya satu item.",

    pleaseSelectAtLeastOneSource: "Silakan pilih setidaknya satu sumber.",
    invalidFileFormatPleaseUploadValidFile:
      "Format file tidak valid. Silakan unggah file .xml, .kml, atau .geojson.",
    pleaseUploadAValidFile: "Silakan unggah file yang valid.",
    fileUploadedDuccessfully: "File berhasil diunggah!",
    anErrorOccured: "Terjadi kesalahan.",
    successfullyUpdatedDefaultFarmArea:
      "Area pertanian default berhasil diperbarui.",
    pleaseAddProductionPlacesData: "Silakan tambahkan data Tempat Produksi.",
    failedToFetchSettings: "Gagal mengambil pengaturan.",
    updatedDueDiligenceReport: "Laporan due diligence diperbarui.",
    updatedDueDiligenceStatus:
      "Status Uji Tuntas telah diperbarui dengan sukses.",
    failedToWriteDeforestationDataToBlockchain:
      "Gagal menulis data deforestasi ke blockchain, silakan coba lagi.",
    countryIsRequired: "Negara diperlukan",
    dueDiligenceReportsInfo:
      "Dokumentasi rinci yang merangkum temuan dan hasil dari proses uji tuntas. Laporan ini memberikan wawasan tentang penilaian yang dilakukan, termasuk risiko apa pun yang diidentifikasi, status kepatuhan, dan rekomendasi untuk mitigasi atau perbaikan.",
    listOfFarmsTT:
      "Tampilan komprehensif dari ladang, termasuk informasi seperti lokasi produksi, nama produsen, negara operasi, luas lahan dalam hektar, jenis kegiatan pertanian, penilaian terkait deforestasi, dan evaluasi risiko potensial yang terkait dengan operasi ladang.",
    loadingPleaseWait: "Memuat... Mohon tunggu",
    existingProductionPlacesTT:
      "Menampilkan daftar tempat produksi yang ada beserta detail seperti nama produsen, negara, area, jenis, dan status penilaian.",
    successfullyGeneratedEUDRDeforestationStatus:
      "Status deforestasi EUDR berhasil dihasilkan.",
    riskAssessmentAndMitigationTT:
      "Mengidentifikasi risiko potensial dan menerapkan strategi untuk meminimalkan dampaknya atau kemungkinan terjadinya. Ini mencakup mengevaluasi bahaya, menganalisis konsekuensi potensialnya, dan mengembangkan rencana untuk mengatasinya atau menguranginya secara efektif.",
    eudrRefNoTT:
      "Pengenal unik yang diberikan untuk setiap laporan uji tuntas, memfasilitasi pelacakan dan verifikasi kepatuhan dalam kerangka Regulasi Deforestasi Uni Eropa (EUDR).",

    operatorData: "Data Operator",
    supplierData: "Data Pemasok",
    supplierDataTT: "Informasi tentang pemasok.",
    operatorDataTT: "Informasi tentang operator.",
    reportSummary: "Ringkasan Risiko",
    reportSummaryTT: "Ikhtisar singkat laporan.",
    totalNoOfGeofencePolygon: "Jumlah Total Poligon Geofence",
    totalNoOfGeofencePolygonTT: "Jumlah total poligon geofence.",
    totalNoOfGeofencePoint: "Jumlah Total Titik Geofence",
    totalNoOfGeofencePointTT: "Jumlah total titik geofence.",
    totalNoOfFarms: "Jumlah Total Perkebunan",
    totalNoOfFarmsTT: "Jumlah total perkebunan.",
    totalAreaFinalReport: "Total Luas (ha)",
    totalNoOfDeforestation: "Jumlah Total Deforestasi",
    totalNoOfDeforestationTT: "Jumlah total penilaian deforestasi.",
    totalNoOfHighDeforestation: "Jumlah Total Deforestasi Tinggi",
    totalNoOfHighDeforestationTT:
      "Jumlah total perkebunan dengan deforestasi tinggi.",
    totalNoOfRiskAssessments: "Jumlah Total Penilaian Risiko",
    totalNoOfRiskAssessmentsTT: "Jumlah total penilaian risiko.",
    totalNoOfLocalDbHighRiskFarms: "Jumlah Total Risiko Tinggi (Kepatuhan DB Lokal)",
    totalNoOfLocalDbHighRiskFarmsTT: "Jumlah tempat produksi dengan risiko kepatuhan database lokal tinggi.",
    totalNoOfLocalDbMediumRiskFarms: "Jumlah Total Risiko Sedang (Kepatuhan DB Lokal)",
    totalNoOfLocalDbMediumRiskFarmsTT: "Jumlah tempat produksi dengan risiko kepatuhan database lokal sedang.",
    productDetail: "Detail Produk",
    productDetailTT: "Informasi tentang produk.",
    product: "Produk",
    productTT:
      "Nama produk. Mengacu pada barang nyata atau komoditas yang diproduksi, diproduksi, atau diperdagangkan oleh perusahaan atau organisasi, sering kali dikategorikan berdasarkan jenis, karakteristik, atau tujuan.",
    productDescription: "Deskripsi Produk",
    productDescriptionTT:
      "Memberikan penjelasan atau ringkasan tertulis tentang karakteristik, fitur, atau atribut suatu produk, bertujuan untuk memberi informasi kepada pengguna atau pelanggan tentang sifat atau fungsinya.",
    netMass: "Massa Bersih",
    netMassTT:
      "Menunjukkan berat suatu produk atau barang, biasanya tidak termasuk berat kemasan atau bahan terkait lainnya, sering kali dinyatakan dalam satuan massa seperti kilogram atau pon.",
    volume: "Volume",
    volumeTT:
      "Mengacu pada jumlah ruang yang ditempati oleh produk atau zat, biasanya diukur dalam satuan kubik seperti meter kubik atau kaki kubik, digunakan untuk mengukur kapasitas atau kuantitas dalam ruang tiga dimensi.",
    scientificName: "Nama Ilmiah",
    scientificNameTT:
      "Nama taksonomi suatu organisme yang terdiri dari genus dan spesies, misalnya Coffea Arabica, Theobroma cacao L.",
    commonNameTT:
      "Nama yang didasarkan pada bahasa normal kehidupan sehari-hari mis. Kakao, Kopi.",

    declarationStatement: "Pernyataan Deklarasi",
    complianceRiskWarning: "Peringatan Risiko Kepatuhan",
    successfullyUploadedToTheBlockchain:
      "Berhasil! Laporan Due Diligence EUDR telah berhasil diunggah ke Blockchain.",
    issueIdentifiedOnFarms:
      "Masalah telah diidentifikasi di beberapa pertanian yang memerlukan perhatian sebelum melanjutkan ke langkah berikutnya. Anda dapat memilih untuk menangani masalah ini sekarang atau melanjutkan ke langkah berikutnya dan menyelesaikannya nanti.",
    blockchainDescs: [
      "Mengunggah laporan ke blockchain, harap tunggu...",
      "Laporan Due Diligence Anda sedang diunggah ke blockchain. Anda akan diarahkan ke halaman daftar Laporan Due Diligence untuk melihat statusnya.",
    ],
    reportDownloadedSuccessfully: "Laporan berhasil diunduh!",
    operatorDecleration: "Pernyataan Operator",
    supplierDecleration: "Pernyataan Pemasok",
    internalReferenceNumberTT:
      "Nomor referensi internal adalah pengenal unik yang diberikan kepada laporan due diligence di dalam sistem.",
    fRinternalReferenceNumberTT:
      "Nomor referensi internal adalah pengenal unik yang diberikan kepada laporan due diligence di dalam sistem.",
    deleteProductionPlaceData: "Hapus Data Tempat Produksi",
    areYouSureYouWantToContinueThisAction:
      "Apakah Anda yakin ingin melanjutkan tindakan ini?",
    noAssessment: "Nessuna Valutazione",

    analyzingStatus: "Menganalisis Status Deforestasi",
    analyzingDesc:
      "Ladang Anda sedang dianalisis secara otomatis untuk deforestasi. Anda akan diarahkan ke halaman daftar laporan due diligence untuk melihat statusnya.",
    readyToProceed: "Siap untuk Melanjutkan",
    mitigationRequired: "Mitigasi Diperlukan",
    viewSummary: "Lihat Ringkasan",
    viewAssessment: "Lihat Penilaian",
    disputes: "Perselisihan",
    manualRiskMitigation: "Mitigasi Risiko Manual",
    veryHighProbability: "Kemungkinan Sangat Tinggi",
    highProbability: "Kemungkinan Tinggi",
    mediumProbability: "Kemungkinan Sedang",
    lowProbability: "Kemungkinan Rendah",
    veryLowProbability: "Kemungkinan Sangat Rendah",
    zeroProbability: "Kemungkinan Nol/Nyaris Nol",
    manualMitigated: "Dimitigasi Secara Manual",
    disputeDesc:
      "Klik salah satu perselisihan di bawah untuk melihat detail lebih lanjut.",
    geofenceColorCode: "Kode Warna Geofence:",
    noDisputeHaveSubmitted: "Belum ada perselisihan yang diajukan",
    disputeDetails: "Detail Perselisihan",
    chooseDisputeReason: "Pilih Alasan Perselisihan",
    pleaseAttachDoc:
      "Silakan lampirkan dokumen/foto untuk mendukung jawaban Anda.",
    additionalNotes: "Catatan Tambahan",
    aggrementStatement:
      "Saya mengerti bahwa tanah yang terpengaruh tidak akan digunakan untuk pertanian dalam beberapa tahun mendatang.",
    addGeofenceRadius: "Tambahkan Radius Geofence",
    totalGeofenceRadius: "Total Radius Geofence adalah",
    resolutionHistory: "Sejarah Penyelesaian",
    proceed: "Lanjutkan",
    wildFire: "Kebakaran Hutan",
    controlledFire: "Kebakaran Terkendali",
    clearingForAgriculture: "Pembersihan untuk Pertanian dan/atau Perkebunan",
    pestAndDiseases: "Hama dan Penyakit",
    naturalChangesInCanopy:
      "Perubahan Alam pada Kanopi (seperti guguran daun musiman)",
    strongWinds: "Angin Kuat (seperti angin topan atau tornado)",
    otherNaturalDisasters: "Bencana Alam Lainnya",
    flooding: "Banjir",
    logging: "Penebangan Hutan",
    infrastructure: "Infrastruktur",
    urbanization: "Urbanisasi",
    landGrabbingOrPopulationPressure:
      "Penguasaan Tanah, Pertanian Subsisten, atau Tekanan Populasi",
    mining: "Pertambangan",
    plantationForestBeforeDeadline:
      "Ini adalah hutan tanaman atau tanah berhutan, tetapi hutan primer atau hutan yang pulih secara alami diubah menjadi hutan tanaman atau tanah berhutan lainnya sebelum batas waktu (31 Desember 2020)",
    convertedToPlantationForest:
      "Hutan primer atau hutan yang pulih secara alami diubah menjadi hutan tanaman atau tanah berhutan lainnya",
    cultivatedAreaBeforeDeadline:
      "Ini adalah area yang dibudidayakan dan tidak mengalami deforestasi setelah batas waktu (31 Desember 2020)",
    forestStillPreserved:
      "Masih ada hutan di area tersebut, tetapi tidak mengalami deforestasi dan masih terjaga",
    downloadAsPDF: "Unduh sebagai PDF",
    productionPlacesHighDeforestationProbability:
      "Tempat produksi memiliki kemungkinan tinggi untuk deforestasi",
    geofenceHighDeforestationProbability:
      "Geofence memiliki kemungkinan tinggi untuk deforestasi",
    EUDRReferenceNumber: "Nomor Referensi EUDR",
    commonName: "Nama Umum",
    totalNoOfRiskAssessment: "Jumlah Total Penilaian Risiko",
    totalNoOFDeforestationAssessments: "Jumlah Total Penilaian Deforestasi",
    totalNoOfGeofencePoints: "Jumlah Total Titik Geofence",
    totalNoOfGeofencePolygons: "Jumlah Total Poligon Geofence",
    dueDiligenceReportStatus: "Status Laporan Due Diligence",
    undoDelete: "Batalkan Penghapusan",
    analyzingDeforestation: "Menganalisis Deforestasi",
    processingFarm: "Memproses Pertanian",

    uploadingToBlockchain: "Mengunggah laporan ke blockchain, harap tunggu...",
    beingUploadToBlockChain:
      "Laporan Due Diligence Anda sedang diunggah ke blockchain. Anda akan diarahkan ke halaman daftar Laporan Due Diligence untuk melihat statusnya.",
    uploading: "Mengunggah",
    attachFile: "Lampirkan Berkas",
    close: "Tutup",
    status: "Status",
    lotID: "ID Lot",
    noOfFarm: "Jumlah Kebun",
    processingDate: "Tanggal Pemrosesan",
    origin: "Asal",
    selectUsingLots: "Pilih Lokasi Produksi Menggunakan Lot",
    productionPlaceUsingFarms: "Pilih Lokasi Produksi Menggunakan Kebun",
    searchFarmName: "Cari nama kebun",
    viewLocation: "Lihat Geolokasi",
    netMassKG: "Massa Bersih (kg)",
    volumeM3: "Volume (m³)",
    areaInHA: "Luas (ha)",
    eudrUploadedToBlockChain:
      "Sukses! Laporan Due Diligence EUDR telah berhasil diunggah ke Blockchain.",
    viewDeforestationAssessment: "Lihat Penilaian Deforestasi",
    viewDeforestationCertificate: "Lihat Sertifikat Deforestasi",
    selectCountries: "Pilih Negara",
    writingToBlockchain: "Menulis ke Blockchain",

    cattle: "Sapi",
    cocoa: "Kakao",
    coffee: "Kopi",
    wood: "Kayu",
    soya: "Kedelai",
    rubber: "Karet",
    oilPlam: "Minyak sawit",

    subProduct1: "0102 21 , 0102 29 Sapi hidup",
    subProduct2: "0201 Daging sapi, segar atau dingin",
    subProduct3: "0202 Daging sapi, beku",
    subProduct4: "0206 10 Jeroan sapi yang dapat dimakan, segar atau dingin",
    subProduct5: "0206 22 Hati sapi yang dapat dimakan, beku",
    subProduct6:
      "0206 29 Jeroan sapi yang dapat dimakan (tidak termasuk lidah dan hati), dibekukan",
    subProduct7:
      "1602 50 Daging, sisa daging, darah, sapi olahan atau diawetkan lainnya",
    subProduct8:
      "4101 Kulit dan kulit sapi mentah (segar, atau diasinkan, dikeringkan, dikapur, diasamkan atau diawetkan secara lain, tetapi tidak disamak, tidak diolah secara perkamen atau diolah lebih lanjut), dihilangkan bulunya atau dibelah maupun tidak",
    subProduct9:
      "4104 Kulit dan kulit sapi yang disamak atau berkerak, tanpa bulu, dibelah maupun tidak, tetapi tidak diolah lebih lanjut",
    subProduct10:
      "4107 Kulit sapi, diolah lebih lanjut setelah penyamakan atau pengerasan kulit, termasuk kulit yang diolah secara perkamen, tanpa bulu, dibelah maupun tidak, selain kulit samak dari pos 41.14",
    subProduct11: "1801 Biji kakao, utuh atau pecah, mentah atau dipanggang",
    subProduct12: "1802 Cangkang kakao, sekam, kulit dan sisa kakao lainnya",
    subProduct13: "1803 Pasta kakao, dihilangkan lemaknya maupun tidak",
    subProduct14: "1804 Mentega kakao, lemak dan minyak",
    subProduct15:
      "1805 Kakao bubuk, tidak mengandung tambahan gula atau bahan pemanis lainnya",
    subProduct16: "1806 Coklat dan olahan makanan lain yang mengandung kakao",
    subProduct17:
      "0901 Kopi, digongseng atau dihilangkan kafeinnya maupun tidak; sekam dan kulit kopi; pengganti kopi yang mengandung kopi dalam proporsi berapa pun",
    subProduct18: "1207 10 Kacang dan inti sawit",
    subProduct19:
      "1511 Minyak kelapa sawit dan fraksinya, dimurnikan maupun tidak, tetapi tidak dimodifikasi secara kimia",
    subProduct20:
      "1513 21 Inti sawit mentah dan minyak babassu serta fraksinya, dimurnikan maupun tidak, tetapi tidak dimodifikasi secara kimia",
    subProduct21:
      "1513 29 Minyak inti sawit dan babassu serta fraksinya, dimurnikan maupun tidak, tetapi tidak dimodifikasi secara kimia (tidak termasuk minyak mentah)",
    subProduct22:
      "2306 60 Bungkil minyak dan residu padat lainnya dari kacang atau inti sawit, digiling atau dalam bentuk pelet maupun tidak, hasil ekstraksi lemak atau minyak dari kacang atau kernel",
    subProduct23:
      "2905 45 Gliserol, dengan kemurnian 95 % atau lebih (dihitung berdasarkan berat produk kering)",
    subProduct24: "2915 70 Asam palmitat, asam stearat, garam dan esternya",
    subProduct25:
      "2915 90 Asam monokarboksilat asiklik jenuh, anhidrida, halida, peroksida dan asam peroksinya; turunan halogenasi, sulfonasi, nitrasi atau nitrosasinya (tidak termasuk asam format, asam asetat, asam mono-, di- atau trikloroasetat, asam propionat, asam butanoat, asam pentanoat, asam palmitat, asam stearat, garam dan esternya, dan anhidrida asetat)",
    subProduct26: "3823 11 Asam stearat, industri",
    subProduct27: "3823 12 Asam oleat, industri",
    subProduct28:
      "3823 19 Asam lemak monokarboksilat industri; minyak asam dari penyulingan (tidak termasuk asam stearat, asam oleat dan asam lemak minyak tinggi)",
    subProduct29: "3823 70 Alkohol lemak industri",
    subProduct30:
      "4001 Karet alam, balata, gutta-percha, guayule, chicle dan getah alam semacam itu, dalam bentuk asal atau dalam bentuk pelat, lembaran atau strip",
    subProduct31:
      "4005 Karet majemuk, tidak divulkanisasi, dalam bentuk asal atau dalam pelat, lembaran atau strip",
    subProduct32:
      "4006 Karet yang tidak divulkanisasi dalam bentuk lain (misalnya batangan, tabung dan bentuk profil) dan barang (misalnya cakram dan cincin)",
    subProduct33: "4007 Benang dan tali karet yang divulkanisasi",
    subProduct34:
      "4008 Pelat, lembaran, strip, batang dan bentuk profil, dari karet vulkanisasi selain karet keras",
    subProduct35:
      "4010 Belt atau belting pengangkut atau transmisi, dari karet vulkanisasi",
    subProduct36: "4011 Ban pneumatik baru, dari karet",
    subProduct37:
      "4012 Ban pneumatik vulkanisir atau bekas dari karet; ban padat atau bantalan, tapak ban dan penutup ban, dari karet",
    subProduct38: "4013 Ban dalam, dari karet",
    subProduct39:
      "4015 Pakaian dan aksesoris pakaian (termasuk sarung tangan, sarung tangan dan mitt), untuk segala keperluan, dari karet vulkanisasi selain karet keras",
    subProduct40:
      "4016 Barang lain dari karet vulkanisasi selain karet keras, tidak dirinci pada pos lain dalam Bab 40",
    subProduct41:
      "4017 Karet keras (misalnya ebonit) dalam segala bentuk termasuk sisa dan skrap; barang dari karet keras",
    subProduct42: "1201 Kacang kedelai, pecah maupun tidak",
    subProduct43: "1208 10 Tepung dan tepung kacang kedelai",
    subProduct44:
      "1507 Minyak kacang kedelai dan fraksinya, dimurnikan maupun tidak, tetapi tidak dimodifikasi secara kimia",
    subProduct45:
      "2304 Bungkil minyak dan residu padat lainnya, digiling atau tidak atau dalam bentuk pelet, hasil ekstraksi minyak kacang kedelai",
    subProduct46:
      "4401 Kayu bakar, dalam bentuk batang kayu, dalam billet, dalam ranting, dalam kayu bakar atau dalam bentuk semacam itu; kayu dalam bentuk serpihan atau partikel; serbuk gergaji dan limbah serta skrap kayu, diaglomerasi maupun tidak dalam bentuk kayu bulat, briket, pelet atau bentuk semacam itu",
    subProduct47:
      "4402 Arang kayu (termasuk arang tempurung atau arang kacang), diaglomerasi maupun tidak",
    subProduct48:
      "4403 Kayu dalam keadaan kasar, dikupas kulit kayu atau gubalnya maupun tidak, atau berbentuk persegi kasar",
    subProduct49:
      "4404 Kayu Hoop; tiang terbelah; tiang pancang, tiang pancang dan tiang pancang dari kayu, runcing tetapi tidak digergaji memanjang; tongkat kayu, dipotong secara kasar tetapi tidak dibalik, dibengkokkan atau dikerjakan dengan cara lain, cocok untuk pembuatan tongkat jalan, payung, gagang perkakas atau sejenisnya; kayu chip dan sejenisnya",
    subProduct50: "4405 Wol kayu; tepung kayu",
    subProduct51:
      "4406 Bantalan rel kereta api atau trem (ikatan silang) dari kayu",
    subProduct52:
      "4407 Kayu digergaji atau dikelupas memanjang, diiris atau dikupas, diketam, diampelas atau disambung ujung maupun tidak, dengan ketebalan melebihi 6 mm",
    subProduct53:
      "4408 Lembaran untuk pelapisan (termasuk yang diperoleh dengan cara mengiris kayu yang dilaminasi), untuk kayu lapis atau untuk kayu laminasi yang serupa lainnya dan kayu lainnya, digergaji memanjang, diiris atau dikupas, diratakan, diamplas, disambung atau disambung ujung maupun tidak, dengan ketebalan tidak melebihi 6mm",
    subProduct54:
      "4409 Kayu (termasuk strip dan friezes untuk lantai parket, tidak dirakit) dibentuk terus menerus (berlidah, beralur, rabat, dilubangi, bersendi V, manik-manik, dibentuk, dibulatkan atau sejenisnya) di sepanjang tepi, ujung atau mukanya, baik atau tidak direncanakan, diampelas atau bersendi ujung",
    subProduct55:
      "4410 Papan partikel, papan untai berorientasi (OSB) dan papan semacam itu (misalnya, papan wafer) dari kayu atau bahan mengandung lignin lainnya, diaglomerasi dengan resin atau bahan pengikat organik lainnya maupun tidak",
    subProduct56:
      "4411 Papan serat dari kayu atau bahan mengandung lignin lainnya, direkatkan dengan resin atau bahan organik lainnya maupun tidak",
    subProduct57: "4412 Kayu lapis, panel veneer dan kayu laminasi semacam itu",
    subProduct58:
      "4413 Kayu dipadatkan, dalam bentuk balok, pelat, strip atau profil",
    subProduct59:
      "4414 Bingkai kayu untuk lukisan, foto, cermin atau benda semacam itu",
    subProduct60:
      "4415 Kotak pengepakan, kotak, peti, drum dan pengepakan semacam itu, dari kayu; drum kabel dari kayu; palet, palet kotak dan papan muatan lainnya, dari kayu;",
    subProduct61:
      "kerah palet dari kayu (tidak termasuk bahan pengemas yang digunakan secara eksklusif sebagai bahan pengemas untuk menopang, melindungi atau membawa produk lain yang dipasarkan)",
    subProduct62:
      "4416 Tong, tong, tong, bak dan produk-produk tembaga lainnya serta bagiannya, dari kayu, termasuk tongkat",
    subProduct63:
      "4417 Perkakas, badan perkakas, gagang perkakas, badan dan gagang sapu atau sikat, dari kayu; bahan boot atau sepatu dan pohon, dari kayu",
    subProduct64:
      "4418 Pekerjaan tukang kayu dan pertukangan dari kayu, termasuk panel kayu seluler, panel lantai rakitan, sirap dan getar",
    subProduct65: "4419 Peralatan makan dan dapur, dari kayu",
    subProduct66:
      "4420 Kayu marquetry dan kayu hias; peti mati dan kotak untuk perhiasan atau peralatan makan, dan barang semacam itu, dari kayu; patung-patung dan hiasan lainnya, dari kayu; perabot kayu tidak termasuk dalam Bab 94",
    subProduct67: "4421 Barang lainnya dari kayu",
    subProduct68:
      "Pulp dan kertas dari Bab 47 dan 48 dari Tata Nama Gabungan, dengan pengecualian produk berbahan dasar bambu dan produk hasil daur ulang (limbah dan skrap)",
    subProduct69:
      "49 Buku cetak, surat kabar, gambar dan produk industri percetakan lainnya, manuskrip, naskah ketikan dan denah, dari kertas",
    subProduct70:
      "9401 Tempat duduk (selain yang dimaksud dalam pos 9402), dapat diubah menjadi tempat tidur maupun tidak, dan bagiannya, dari kayu",
    subProduct71:
      "9403 30 , 9403 40 , 9403 50 , 9403 60 dan 9403 91 Perabotan kayu dan bagiannya",
    subProduct72: "9406 10 Bangunan prefabrikasi dari kayu",

    selectStatus: "Pilih Status",
    compilanceRiskWarning: "Peringatan Risiko Kepatuhan",
    operatorDeclerationTT: "Pernyataan pernyataan oleh operator.",
    supplierDeclerationTT: "Pernyataan pernyataan oleh pemasok.",

    blockchainVerifikasi: "Verifikasi Blockchain",
    scanQrBlockchain:
      "Pindai kode QR ini untuk melihat Laporan Uji Tuntas EUDR di blockchain.",
    unduhQrCode: "Unduh Kode QR",
    eudrPublicReport: "Laporan Publik Uji Tuntas Dimitra EUDR",
    scanQrEudr:
      "Pindai kode QR ini untuk melihat Laporan Uji Tuntas EUDR di web publik.",
    viewReportForPublic: "Klik Disini untuk Melihat Laporan untuk Publik",
    viewReportOnBlockChain: "Klik Disini untuk Melihat Laporan di Blockchain",
    riskAssessmentNotApproved: "tempat produksi tidak disetujui.",
    blockchainVerification: "Verifikasi Blockchain",
    declarationMissing: "Deklarasi Hilang",
    removeRiskFarms: "HAPUS PERTANIAN BERISIKO",
    disregardRiskDocument: "ABAIKAN PERTANIAN BERISIKO",
    attachRiskMitigationDocumentForNonCompliantFarms: "LAMPIRKAN DOKUMEN MITIGASI RISIKO UNTUK SEMUA PERTANIAN YANG TIDAK PATUH",
    uploadMitigationDocumentForNonCompliantFarms: `Mengunggah dokumen mitigasi risiko untuk semua pertanian yang tidak patuh akan mengubah status pertanian dengan "Mitigasi Diperlukan" menjadi "Dimitigasi Secara Manual".`,
    disregardFarmWithIssuesTitle: "Abaikan Pertanian",
    disregardFarmWithIssuesMessage: "Dengan memilih 'Abaikan,' status penilaian risiko yang hilang untuk pertanian tidak akan dipertimbangkan dalam laporan ini. Pertanian akan tetap menjadi bagian dari laporan, tetapi penilaian yang tertunda tidak akan mempengaruhi status kepatuhan. Harap konfirmasi bahwa Anda ingin melanjutkan.",
    removeRiskFarmTitle: "Hapus Pertanian",
    removeRiskFarmMessage: "Dengan memilih 'Hapus,' pertanian dengan penilaian risiko yang hilang akan dihapus dari laporan. Harap konfirmasi bahwa Anda ingin melanjutkan.",

    fileName: "Nama file",
    dateAndTime: "Tanggal dan waktu",
    downloadProgressStatus: "Status kemajuan unduhan",
    downloadHistory: "Riwayat unduhan",
    downloaded: "Diunduh",
    inprogress: "Sedang berlangsung",
    failed: "Gagal",
    showAllDownloads: "Tampilkan semua unduhan",
    inProgress: "Sedang berlangsung",
    downloadCompleted: "Unduhan selesai",
    downloadFailed: "Unduhan gagal",
    errorDeletingItem: "Tidak dapat menghapus item. Silakan coba lagi nanti.",
    anErrorOccuredPlsTryAgain: "Terjadi kesalahan. Silakan coba lagi.",
    invalidData: "Data yang diberikan tidak valid. Silakan periksa dan coba lagi.",
    fileIsReady: "File siap digunakan",
    invalidFilePathOrUrl: "Path atau URL file tidak valid.",
    errorDownloadingFile: "Ada masalah saat mengunduh file. Silakan coba lagi.",
    downloadInitiated: "Unduhan dimulai",
    beingDownloaded: "sedang diunduh. Waktu estimasi",

    multiStepSurveyDetails: "Berdasarkan jumlah pertanyaan dalam satu langkah, semua pertanyaan dalam survei akan dikelompokkan dan ditampilkan dalam langkah-langkah. Namun, konfigurasi ini hanya tersedia sebelum menambahkan pertanyaan atau subjudul. Setelah pertanyaan atau subjudul ditambahkan, konfigurasi Multi-Langkah akan dinonaktifkan secara otomatis. Silakan hapus pertanyaan atau subjudul untuk mengaktifkan kembali opsi ini.",
    estimatedTime: "Waktu perkiraan",
    tryAgain: "Coba lagi",
    enableRiskWarnings: "Aktifkan peringatan risiko",
    connectedFarmer: "Kopi",
    assessmentNameInfo: "Fungsi untuk menemukan penilaian atau informasi spesifik.",
    finishStepsTooltip: "Selesaikan Langkah 1–3 dengan mengeklik ‘Berikutnya’ pada masing-masing langkah untuk membuka tab ini.",
    viewDownloadHistory: "Lihat Riwayat Unduhan",
    eudrDocumentCodes: "Kode Dokumen EUDR",
    referenceNumberForC717: "Nomor Referensi untuk C717",
    exporterData: "Data Eksportir",
    reportSharedSuccessfully: "Laporan berhasil dibagikan",
    shareReportWithExporter: "Bagikan Laporan ke Eksportir",
    shareReadOnlyReport: "Bagikan Laporan Hanya-Baca",
    shareReportToOperator: "Bagikan Laporan ke Operator",
    verificationNumber: "Nomor Verifikasi",
    dueDiligenceReport: "Laporan Due Diligence",
    productDetails: "Detail Produk",

    accessAndVerify: "Akses dan Verifikasi Laporan Due Diligence",
    searchReportOrShipmentTitle: "Masukkan ID Laporan atau ID Shipment yang disediakan oleh Eksportir untuk melihat detail laporan.",
    searchReportOrShipmentPlaceholder: "Cari berdasarkan ID Laporan atau ID Shipment",
    reportStatus: "Status Laporan",
    assignedTo: "Dialokasikan ke",

    assignReports: "Dialokasikan Laporan",
    approveReports: "Setujui Laporan",
    rejectReports: "Tolak Laporan",
    reportsSelected: "Laporan Terpilih",
    daysOld: "Hari Lama",

    approvalConfirmationTitle: "Konfirmasi",
    approvalConfirmationMessage: "Apakah Anda yakin ingin menyetujui laporan DDS yang dipilih?",
    approvalOnceApprovedTitle: "Setelah disetujui",
    approvalVerifiedByPtsi: "Setiap laporan akan ditandai sebagai terverifikasi oleh PTSI.",
    approvalVerifiedByAgent: "Setiap laporan akan ditandai sebagai terverifikasi oleh NACCU.",
    approvalConfirmationMessageShipment: "Are you sure you want to approve the selected shipments?",
    approvalVerifiedByShipment: "Setiap pengiriman akan ditandai sebagai disetujui",
    allAssociatedReportsWillBeApprovedShipment: "Semua laporan terkait akan disetujui",
    approvalVerificationLinksShipment: "Tautan verifikasi dan kode QR akan dihasilkan.",
    approvalNoFurtherChangesShipment: "Tidak ada perubahan lebih lanjut yang diizinkan.",
    approvalPublishedToBlockchainShipment: "Pengiriman & Laporan akan dipublikasikan ke Blockchain dan tersedia di web publik Dimitra.",
    allAssociatedReportsWillBeApproved: "Semua laporan terkait akan disetujui",
    approvalVerificationLinks: "Tautan verifikasi dan kode QR akan dihasilkan untuk setiap laporan.",
    approvalNoFurtherChanges: "Tidak ada perubahan lebih lanjut yang diizinkan pada laporan yang disetujui.",
    approvalPublishedToBlockchain: "Pengiriman & Laporan akan dipublikasikan ke Blockchain dan tersedia di web publik Dimitra.",
    temporaryApprovalLabel: "Disetujui Sementara",
    temporaryApprovalDescription: "Semua pertanian yang tidak patuh akan ditandai sebagai dimitigasi secara manual untuk periode ini. Setelah masa berlaku berakhir, status kepatuhan mereka akan kembali ke kondisi semula.",
    approvalExpirationPeriod: "Periode Kadaluarsa Setujui",
    approvalExpirationDays: "Hari",
    approvalExpirationWeeks: "Minggu",
    approvalExpirationMonths: "Bulan",
    approvalExpirationYears: "Tahun",
    approvalCancelButton: "BATAL",
    approvalApproveButton: "SETUJUI",
    approvalSignatureRequired: "Tanda tangan direktur / peninjau",
    approvalSignatureHint: "Unggah gambar tanda tangan. Akan ditampilkan di halaman Legal Proof DDS setelah disetujui.",
    approvalSignatureHintOptional: "Opsional jika tanda tangan sudah diunggah saat verifikasi pembayaran. Jika belum, unggah di sini untuk halaman Legal Proof.",
    approvalSignatureUpload: "Unggah tanda tangan (PNG atau JPG)",
    approvalSignatureRequiredError: "Harap unggah tanda tangan sebelum menyetujui.",
    approvalSignaturePreview: "Pratinjau Tanda Tangan",
    ptsiAuthorizedSignatoryTitle: "Penandatangan PTSI yang Berwenang",
    ptsiVerifyOnBehalfHint: "Dengan menyetujui pembayaran ini, Anda mengonfirmasi verifikasi atas nama penandatangan resmi di bawah. Halaman Legal Proof akan menampilkan detail penandatangan tetap tersebut.",
    ptsiApproveOnBehalfHint: "Dengan menyetujui laporan ini, Anda mengonfirmasi atas nama penandatangan resmi di bawah. Sampul Legal Proof akan menampilkan detail penandatangan tetap.",
    signatoryName: "Nama",
    signatoryPosition: "Jabatan",
    signatoryCompany: "Perusahaan",
    digitalSignatureLater: "Akan ditambahkan nanti",
    changeSignature: "Ubah tanda tangan",
    ptsiReviewerSignatureHint: "Tambahkan tanda tangan di atas atas nama penandatangan resmi. Tanda tangan akan ditampilkan di halaman Legal Proof DDS setelah disetujui.",
    verifyingAsReviewer: "Memverifikasi sebagai (peninjau yang login)",
    reviewerName: "Nama peninjau",
    reviewerEmail: "Email peninjau",

    approveShipmentsConfirmation: "Apakah Anda yakin ingin menyetujui pengiriman yang dipilih?",
    onceApproved: "Setelah disetujui:",
    shipmentMarkedVerified: "Setiap pengiriman akan ditandai sebagai terverifikasi oleh PTSI.",
    verificationLinksGenerated: "Tautan verifikasi dan kode QR akan dihasilkan untuk setiap pengiriman.",
    noFurtherChanges: "Tidak ada perubahan lebih lanjut yang diizinkan pada pengiriman yang disetujui.",
    publishedToBlockchain: "Pengiriman akan dipublikasikan ke Blockchain dan tersedia di web publik Dimitra.",
    
    rejectionWarningTitle: "Peringatan",
    rejectionConfirmationMessage: "Apakah Anda yakin ingin menolak laporan DDS yang dipilih?",
    rejectionReasonLabel: "Alasan Penolakan",
    rejectionReasonPlaceholder: "Komentar",
    rejectionReasonRequired: "Silakan berikan alasan penolakan",
    rejectionDataSaved: "Data laporan akan disimpan setelah penolakan dalam hal Anda ingin melihatnya kembali nanti.",
    rejectionCancelButton: "BATAL",
    rejectionConfirmButton: "KONFIRMASI",
    rejectionNote: "Silakan Perhatikan",

    waitingForPaymentBannerMessage: "Laporan DDS ini memiliki pembayaran yang tertunda. Bagikan laporan Anda kepada Eksportir dan lanjutkan pembayaran yang tertunda untuk melanjutkan Proses Persetujuan.",
    waitingForPaymentSubmittedTo: "Dikirim kepada {exporters}.",
    paymentResponsibilityTitle: "Tanggung Jawab Pembayaran",
    paymentResponsibilityDescription: "Laporan DDS ini telah dibagikan kepada Anda sebagai eksportir. Apakah Anda menerima tanggung jawab untuk pembayaran biaya peninjauannya?",
    paymentResponsibilityWireTransferNote: "Pembayaran untuk DDS ini harus dilakukan melalui transfer bank.",
    ddsReferenceNo: "No. Referensi DDS",
    quantityTons: "Kuantitas / Ton",
    acceptPaymentResponsibility: "Terima",
    declinePaymentResponsibility: "Tolak",
    paymentResponsibilityAccepted: "Anda telah menerima tanggung jawab pembayaran untuk laporan ini.",
    paymentResponsibilityDeclined: "Anda telah menolak tanggung jawab pembayaran untuk laporan ini.",
    acceptingPaymentResponsibility: "Menerima tanggung jawab pembayaran...",
    decliningPaymentResponsibility: "Menolak tanggung jawab pembayaran...",
    releasePaymentResponsibility: "Keluar dari Tanggung Jawab Pembayaran",
    releasePaymentResponsibilityConfirm: "Keluar dari tanggung jawab pembayaran untuk laporan ini? Eksportir lain yang dibagikan dapat menerima dan melanjutkan pembayaran.",
    paymentResponsibilityReleased: "Tanggung jawab pembayaran dilepaskan. Eksportir lain sekarang dapat menerimanya.",
    exporterLockedOutByPayment: "Laporan DDS ini tidak lagi tersedia untuk Anda karena eksportir lain telah menerima tanggung jawab pembayaran.",
    paymentAssignedToAnotherExporter: "Pembayaran Tidak Tersedia",
    paymentUnavailableTooltip: "Tanggung jawab pembayaran sudah diterima oleh eksportir lain.",

    reportPayment: "Lanjutkan Pembayaran",
    paymentAmountDue: "Jumlah yang Harus Dibayar",
    bankTransferDetails: "Detail Transfer Bank",
    uploadReceipt: "Unggah Bukti Pembayaran",
    uploadReceiptPlaceholder: "Pilih file bukti transfer bank",
    uploadReceiptHint: "Unggah gambar atau PDF bukti transfer bank yang jelas.",
    uploadReceiptRequired: "Silakan unggah bukti pembayaran",
    paymentTransactionNote: "Catatan Transaksi (Opsional)",
    paymentTransactionNotePlaceholder: "Tambahkan referensi bank, tanggal transfer, atau catatan pembayaran lainnya",
    reportPaymentSubtitle: "Kirim bukti transfer bank untuk pembayaran biaya peninjauan DDS",
    submitPayment: "Kirim Pembayaran",
    submittingPayment: "Mengirim pembayaran...",
    uploadingReceipt: "Mengunggah bukti pembayaran...",
    paymentReportedSuccessfully: "Pembayaran berhasil dilaporkan. PTSI akan segera memverifikasinya.",
    paymentReportedByExporterNotice: "DDS ini telah dibagikan kepada eksportir, sehingga eksportir bertanggung jawab untuk melaporkan pembayaran.",
    verifyPayment: "Verifikasi Pembayaran",
    verifyPaymentReceipt: "Verifikasi Bukti Pembayaran",
    verifyPaymentSubtitle: "Tinjau detail invoice dan bukti pembayaran yang diunggah sebelum menyetujui atau menolak.",
    receiptPreview: "Pratinjau Bukti",
    loadingReceipt: "Memuat bukti…",
    receiptPreviewUnavailable: "Tidak dapat memuat pratinjau bukti. Coba lagi atau buka di tab baru.",
    receiptPreviewUnsupported: "Jenis file ini tidak dapat dipratinjau di sini. Buka di tab baru untuk meninjau.",
    receiptPreviewRetry: "Coba lagi",

    paymentVerified: "Pembayaran Terverifikasi",
    paymentRejected: "Pembayaran Ditolak",
    paymentPendingVerification: "Menunggu Verifikasi",
    paymentPayer: "Pembayar",
    paymentReceipt: "Bukti Pembayaran",
    paymentRejectionReasonLabel: "Alasan Penolakan",
    paymentRejectionReasonRequired: "Silakan berikan alasan penolakan pembayaran ini",
    approvePayment: "Konfirmasi",
    rejectPayment: "Tolak",
    approvingPayment: "Mengonfirmasi pembayaran...",
    rejectingPayment: "Menolak pembayaran...",
    generateInvoice: "Buat Faktur",
    invoiceGeneratedSuccessfully: "Faktur berhasil dibuat.",
    viewInvoice: "Lihat Faktur",
    viewInvoiceAndReceipt: "Lihat Faktur & Bukti",
    submittedPaymentProof: "Bukti Pembayaran yang Dikirim",
    receiptSubmittedBy: "Dikirim Oleh",
    receiptSubmittedAt: "Dikirim Pada",
    receiptSubmittedByYou: "Anda",
    receiptSubmittedByAnotherExporter: "Eksportir lain",
    receiptNotSubmittedYet: "Belum ada bukti pembayaran yang dikirim.",
    openSubmittedReceipt: "Buka Bukti yang Dikirim",
    paymentProofNote: "Catatan Transaksi",
    paymentProofHintYou: "Ini adalah bukti pembayaran yang Anda kirim untuk faktur ini.",
    paymentProofHintOther: "Bukti pembayaran dikirim oleh eksportir lain yang menerima tanggung jawab pembayaran.",

    downloadInvoice: "Unduh Faktur",
    ddsReviewFeeInvoice: "Faktur Biaya Peninjauan DDS",
    invoiceHeader: "Header Faktur",
    invoiceNumber: "Nomor Faktur",
    invoiceDate: "Tanggal Faktur",
    paymentStatus: "Status Pembayaran",
    invoiceGeneratedStatus: "Faktur Dibuat",
    payerInformation: "Informasi Pembayar",
    exporterName: "Nama Eksportir",
    exporterCompanyId: "ID Eksportir / ID Perusahaan",
    exporterContact: "Kontak / Email Eksportir",
    ddsProductInformation: "Informasi DDS / Produk",
    quantityNetMass: "Kuantitas / Massa Bersih",
    unit: "Satuan",
    unitTon: "Ton",
    pricingInformation: "Informasi Harga",
    calculatedAmount: "Jumlah Terhitung",
    paymentInformation: "Informasi Pembayaran",
    totalAmountPayable: "Total Jumlah yang Harus Dibayar",
    bankAccountInstructions: "Rekening Bank / Instruksi Pembayaran",
    bankTransferPaymentInstructions: "Silakan transfer total jumlah yang harus dibayar ke rekening bank di bawah ini dan unggah bukti pembayaran Anda.",
    paymentDueStatus: "Status Jatuh Tempo Pembayaran",
    paymentDue: "Menunggu Pembayaran",
    paymentPaid: "Lunas",
    bankDetails: "Detail Bank",
    bankName: "Nama Bank",
    accountName: "Nama Rekening",
    accountNumber: "Nomor Rekening",
    invoiceFooterNote: "Faktur ini diterbitkan untuk pembayaran biaya peninjauan DDS. Simpan salinan untuk catatan Anda.",
    ddsPaymentPricingTitle: "Harga Pembayaran DDS",
    ddsPaymentPricingSubtitle: "Atur harga per ton yang dikenakan untuk peninjauan DDS, berdasarkan produk dan negara. Harga dicocokkan dengan negara terdaftar organisasi pelapor. Laporan untuk produk tanpa harga yang dikonfigurasi akan melewati tahap pembayaran.",
    pricePerTon: "Harga per Ton",
    ddsPricePerTon: "Harga per Ton DDS",
    currency: "Mata Uang",
    pricingCountry: "Negara",
    pricingProduct: "Produk",
    pricingActions: "Tindakan",
    addPricing: "Tambah Harga",
    updatePricing: "Perbarui Harga",
    pricingSavedSuccessfully: "Harga berhasil disimpan.",
    deletePricing: "Hapus Harga",
    pricingDeleteConfirm: "Apakah Anda yakin ingin menghapus pengaturan harga ini?",
    pricingDeletedSuccessfully: "Pengaturan harga berhasil dihapus.",
    noPricingSettingsConfigured: "Belum ada pengaturan harga yang dikonfigurasi.",
    organizationCountryLabel: "Negara Organisasi",
    organizationCountrySubtitle: "Negara terdaftar untuk organisasi Anda. Digunakan untuk mencocokkan harga pembayaran DDS yang dikonfigurasi berdasarkan negara.",
    organizationCountrySavedSuccessfully: "Negara organisasi berhasil disimpan.",
    enterPricePerTon: "Masukkan Harga per Ton",
    selectCurrency: "Pilih Mata Uang",
    pleaseSelectUserToAssign: "Silakan pilih pengguna untuk dialokasikan laporan DDS yang dipilih. Setelah dialokasikan, pengguna akan diberitahu dan diberikan akses untuk mengelola laporan ini. Anda dapat dialokasikan kembali jika diperlukan.",
    selectUser: "Pilih Pengguna",
    assignShipmentDescription: "Silakan pilih pengguna untuk menugaskan pengiriman yang dipilih. Setelah ditugaskan, pengguna akan diberitahu dan diberikan akses untuk mengelola pengiriman ini. Anda dapat menugaskan kembali nanti jika diperlukan.",
    selectUserTooltip: "Pilih pengguna untuk menugaskan laporan yang dipilih",
    selectUserPlaceholder: "Pilih pengguna",
    search: "Cari",
    assignButton: "TUGASKAN",
    pleaseSelectUser: "Silakan pilih pengguna",
    rejectShipmentsConfirmation: "Apakah Anda yakin ingin menolak pengiriman yang dipilih?",
    shipmentDataSaved: "Data pengiriman ini akan disimpan setelah penolakan jika Anda ingin meninjau kembali nanti.",
    chooseUserToAssign: "Pilih pengguna untuk dialokasikan laporan yang dipilih",
    assign: "Dialokasikan",

    // approval dashboard translations
    today: "Hari Ini",
    week: "Minggu",
    month: "Bulan",
    year: "Tahun",
    all: "Semua",
    selectDateRange: "Pilih Rentang Tanggal",
    selectStartDate: "Pilih Tanggal Mulai",
    selectEndDate: "Pilih Tanggal Berakhir",
    apply: "Terapkan",
    activeCooperatives: "Koperasi Aktif",
    activeUnionAgents: "Agen Serikat Aktif",
    numberActiveCooperatives: "Jumlah koperasi aktif dalam sistem",
    activeExporters: "Eksportir Aktif",
    totalNumberRegisteredFarms: "Jumlah total pertanian yang terdaftar dalam sistem",
    registeredFarms: "Pertanian Terdaftar",
    ddsCompliant: "DDS Patuh",
    numberDdsReportsCompliant: "Jumlah laporan DDS yang patuh",
    ddsApproved: "DDS Disetujui",
    numberDdsReportsApproved: "Jumlah laporan DDS yang telah disetujui",
    ddsAssignedToMe: "DDS Ditugaskan Kepada Saya",
    numberDdsReportsAssignedToMe: "Jumlah laporan DDS yang ditugaskan kepada saya",
    ddsOverdue: "DDS Terlambat",
    numberDdsReportsOverdue: "Jumlah laporan DDS yang sudah melewati tenggat waktu",
    ddsNonCompliant: "DDS Tidak Patuh",
    numberDdsReportsNonCompliant: "Jumlah laporan DDS yang tidak patuh",
    ddsRejected: "DDS Ditolak",
    numberDdsReportsRejected: "Jumlah laporan DDS yang telah ditolak",
    selectRegion: "Pilih Wilayah",
    resetFilters: "Atur Ulang Filter",
    selectDate: "Pilih Tanggal",
    start: "Mulai",
    end: "Akhir",
    date: "Tanggal",
    averageProcessingTimeDays: "Rata-rata Waktu Pemrosesan (Hari)",
    assignedEmployees: "Karyawan yang Ditugaskan",
    reportsProcessed: "Laporan yang Diproses",
    averageTime: "Waktu Rata-rata",
    averageTimeToProcessDdsReport: "Rata-rata Waktu untuk Memproses Laporan DDS",
    filterBy: "Filter Berdasarkan",
    loadingChartData: "Memuat data grafik...",
    noDataAvailable: "Tidak ada data yang tersedia",
    ddsReports: "Laporan DDS",
    comprehensiveViewOfAllDueDiligenceReportsAndTheirStatus: "Tampilan komprehensif dari semua laporan due diligence dan statusnya",
    ddsReportSubmissions: "Pengajuan Laporan DDS",
    monthlyBreakdownOfDdsReportSubmissionsByStatus: "Rincian bulanan pengajuan laporan DDS berdasarkan status",
    ddsReportsByProducts: "Laporan DDS berdasarkan Produk",
    ddsReportsByStatus: "Laporan DDS berdasarkan Status",
    allProducts: "Semua Produk",
    
    // Status labels for DDS Reports
    statusLabels: {
      pending_approval: "Menunggu Persetujuan",
      overdue: "Terlambat",
      approved: "Disetujui",
      rejected: "Ditolak",
      processing: "Sedang Diproses",
      compliant: "Patuh",
      non_compliant: "Tidak Patuh",
      under_review: "Sedang Ditinjau",
      temporary_approved: "Disetujui Sementara",
      shipment_in_process: "Pengiriman Dalam Proses"
    },
    numberActiveExporters: "Jumlah eksportir aktif dalam sistem",
    ddsReportsApproved: "Laporan DDS Disetujui",
    pendingDdsReports: "Laporan DDS Tertunda",
    overdueDdsReports: "Laporan DDS Terlambat",
    rejectedDdsReports: "Laporan DDS Ditolak",
    applyFilter: "Terapkan Filter",
    makeSelection: "Pilih",
    
    assignToMe: "Dialokasikan ke Saya",
    assignToMeConfirmation: "Apakah Anda yakin ingin menyalokasikan laporan DDS ini ke diri Anda sendiri? Setelah dialokasikan, Anda akan menjadi pemilik laporan ini dan bertanggung jawab untuk meninjau dan menyelesaikannya.",
    assignToMeConfirmButton: "YA, DIALOKASIKAN KE SAYA",
    onlyReportsAssignedToYouCanBeSelected: "Hanya laporan yang dialokasikan ke Anda yang dapat dipilih",
    thisReportIsAssignedTo: "Laporan ini dialokasikan ke {assignedUserName}. Hanya laporan yang dialokasikan ke Anda yang dapat dipilih.",
    thisReportIsNotAssignedToAnyoneOnlyReportsAssignedToYouCanBeSelected: "Laporan ini tidak dialokasikan ke siapa pun. Hanya laporan yang dialokasikan ke Anda yang dapat dipilih.",
    noReportSelectedForAssignment: "Tidak ada laporan yang dipilih untuk dialokasikan",
    userInformationNotAvailable: "Informasi pengguna tidak tersedia",
  
    checkingComplianceStatus: "Memeriksa status kepatuhan...",
    nonCompliantFarmsDetected: "Perkebunan dengan Risiko Terdeteksi",
    approvalCompliantAndManuallyMitigated: "Status laporan akan diubah menjadi Patuh dan Pertanian dengan masalah atau status tidak patuh akan diubah menjadi Mitigasi Secara Manual.",
    approvalCompliantAndRiskDetected: "Status laporan akan diubah menjadi Patuh dan Pertanian dengan masalah atau status tidak patuh akan diubah menjadi Risiko Terdeteksi.",
  
    additionalInformationRequested: "Informasi Tambahan Diminta",
    supplierUpdates: "Pembaruan Pemasok",
    noDescriptionProvided: "Tidak ada deskripsi yang diberikan",
    supplierHasRespondedAndMadeUpdates: "Pemasok telah merespons permintaan informasi tambahan Anda dan membuat pembaruan berikut pada laporan DDS ini:",
    removedFarms: "Pertanian Dihapus",
    updatedFarms: "Pertanian Diperbarui",
    addedNewFarms: "Pertanian Baru Ditambahkan",
    noFarmChanges: "Tidak ada perubahan pertanian",
    farmsAdded: "Pertanian Ditambahkan",
    farmsRemoved: "Pertanian Dihapus",
    farmsUpdated: "Pertanian Diperbarui",
    addressOfProduction: "Alamat Produksi",
    
    // Production Place Expandable Row Translations
    locationStatus: "Status Lokasi",
    viewFarm: "Lihat Pertanian",
    locationStatusTT: "Status verifikasi koordinat lokasi dan batas tempat produksi.",
    locationVerified: "Lokasi Terverifikasi",
    locationError: "Kesalahan Lokasi",
    geofenceError: "Kesalahan Geofence",
    farmOverlapped: "Pertanian Tumpang Tindih",
    countryMismatchError: "Negara Produksi berbeda dari Lokasi Geofence Pertanian.",
    circularFarmAreaTooLarge: "Pertanian Melingkar lebih dari 4.0 HA dalam Luas.",
    farmOverlapMessage: "Geofence pertanian tumpang tindih dengan pertanian lain {farmName}",
    farmOverlapGeneric: "Geofence pertanian tumpang tindih dengan pertanian lain",
    dateOfIssue: "Tanggal Penerbitan",
    dateOfExpiry: "Tanggal Kadaluarsa",
    dateOfSubmission: "Tanggal Pengajuan",
    assessments: "Penilaian",
    riskAssessmentTT: "Penilaian risiko mengevaluasi potensi ancaman dan persyaratan kepatuhan untuk tempat produksi.",
    noRiskAssessment: "Tidak Ada Penilaian Risiko Tersedia",
    indigenousAndProtectedAreas: "Wilayah Adat & Kawasan Lindung",
    indigenousAndProtectedAreasTT: "Verifikasi apakah tempat produksi berpotongan dengan wilayah adat atau kawasan lindung.",
    interceptsProtectedArea: "Berpotongan dengan Kawasan Lindung",
    interceptsProtectedAreaTT: "Menunjukkan apakah tempat produksi tumpang tindih dengan kawasan lindung.",
    interceptsIndigenousArea: "Berpotongan dengan Wilayah Adat",
    interceptsIndigenousAreaTT: "Menunjukkan apakah tempat produksi tumpang tindih dengan wilayah adat.",
    mitigationDocuments: "Dokumen Mitigasi",
    mitigationDocumentsTT: "Dokumen yang diunggah untuk menunjukkan langkah-langkah mitigasi risiko yang diambil untuk tempat produksi.",
    localDbMitigationDocuments: "Kepatuhan DB Lokal",
    eudrMitigationDocuments: "Deforestasi EUDR",
    otherMitigationDocuments: "Lainnya",
    noMitigationDocumentsForSource: "Tidak ada dokumen mitigasi yang diunggah dari sumber ini.",
    noMitigationDocuments: "Tidak Ada Dokumen Mitigasi Tersedia",
    mitigationComments: "Komentar",
    noMitigationComments: "Tidak ada komentar tersedia",
    showDetails: "Tampilkan Detail",

    hideDetails: "Sembunyikan Detail",
    ddsReportLog: "Log Laporan DDS",
    ddsReportLogTT: "Log Laporan DDS mencatat berbagai aktivitas terkait dengan laporan DDS itu sendiri",
    ddsApprovalLog: "Log Persetujuan DDS",
    ddsApprovalLogTT: "Log Persetujuan DDS mencatat berbagai aktivitas terkait dengan alur persetujuan laporan DDS",

    downloadPdfWithAccessKey: "Unduh PDF dengan Kode Akses",
    ddsReportExchange: "Pertukaran Laporan DDS",
    importDdsReport: "Impor Laporan DDS",
    exchangeRequests: "Permintaan Pertukaran",
    importDdsReportDescription: "Jika Anda berdagang dengan perusahaan yang juga menggunakan Platform Due Diligence Dimitra, Anda dapat langsung mengimpor laporan Due Diligence mereka. Anda dapat memasukkan Nomor Referensi Internal untuk mengirim permintaan persetujuan atau memasukkan Kode Akses yang diberikan oleh perusahaan untuk akses instan. Setelah disetujui, laporan akan tersedia di bagian 'Laporan Due Diligence'.",
    selectMethodOfImport: "Pilih Metode Impor",
    requestInternalRefNumber: "Permintaan Nomor Referensi Internal",
    iHaveAccessCode: "Saya memiliki Kode Akses",
    accessCode: "Kode Akses",
    accessCodeTooltip: "Masukkan kode akses yang diberikan oleh perusahaan untuk mengimpor laporan DDS mereka.",
    enterHere: "Masukkan di sini",
    internalRefRequestTooltip: "Masukkan nomor referensi internal untuk mengirim permintaan ke perusahaan.",
    accessTheReport: "AKSES LAPORAN",
    exchangeRequestsTabDescription: "Lihat dan kelola permintaan pertukaran laporan DDS Anda.",
    exchangeHistory: "Riwayat Pertukaran",
    exchangeHistoryDescription: "Di bawah ini adalah riwayat laporan DDS yang telah Anda impor dari perusahaan lain melalui Platform Due Diligence Dimitra. Anda dapat melacak status permintaan yang tertunda, melihat laporan yang dibagikan dengan Anda melalui Nomor Referensi, atau mengakses laporan yang dibuka menggunakan Kode Akses.",
    incomingReportRequests: "Permintaan Laporan Masuk",
    incomingReportRequestsTooltip: "Permintaan berbagi laporan yang dikirim kepada Anda oleh pengguna lain.",
    incomingReportRequestsDescription: "Di sini Anda dapat melihat semua permintaan berbagi laporan dari pengguna lain. Silakan tinjau permintaan dan setujui atau tolak. Permintaan yang disetujui memberikan akses ke laporan lengkap.",
    ddsInternalReferenceNo: "No. Referensi Internal DDS",
    productFilterTooltip: "Filter berdasarkan nama atau kode produk.",
    requestApproved: "Permintaan disetujui.",
    requestRejected: "Permintaan ditolak.",
    approve: "Setujui",
    reject: "Tolak",
    requestId: "ID Permintaan",
    enterprise: "Perusahaan",
    importMethod: "Metode Impor",
    requestStatus: "Status Permintaan",
    requestIdDate: "ID Permintaan / Tanggal",
    requestingEnterpriseNameId: "Nama Perusahaan Pemohon / ID",
    productQuantity: "Produk/Jumlah",
    dueDiligenceStatus: "Status Due Diligence",
    compliant: "Patuh",
    accessReportSuccess: "Permintaan akses laporan berhasil.",
    requestSent: "Permintaan berhasil dikirim.",
    copied: "Disalin",
    downloadPdfWithAccessKeyConfirmQuestion: "Apakah Anda yakin ingin mengunduh laporan DDS ini dengan kode akses?",
    downloadPdfWithAccessKeyExplanation: "Kode akses memungkinkan penerima untuk mengimpor data DDS ini ke akun mereka. Mereka akan memiliki semua informasi yang dilampirkan ke DDS. Jika Anda tidak ingin memberikan akses DDS penuh, unduh PDF standar tanpa kode akses.",
    downloadPdfWithAccessKeyError: "Unduhan gagal. Server mungkin belum mendukung PDF dengan kode akses.",
    shareReport: "Bagikan Laporan",
    shareReportWithInternalUser: "Bagikan Laporan dengan Pengguna Dimitra Internal",
    shareReportWithInternalUserTooltip: "Bagikan laporan ini dengan pengguna yang terdaftar di platform Dimitra.",
    shareReportWithExternalUser: "Bagikan Laporan dengan Pengguna Eksternal melalui Email",
    shareReportWithExternalUserTooltip: "Bagikan laporan ini dengan pengguna eksternal melalui email.",
    enterUserEmail: "Masukkan Email Pengguna",
    userSearchError: "Gagal mencari pengguna. Anda masih dapat melanjutkan dengan berbagi.",
    pleaseEnterEmail: "Silakan masukkan alamat email.",
    shareReportError: "Gagal membagikan laporan. Silakan coba lagi.",
    accessLevel: "Tingkat Akses",
    shareFullDataReport: "Bagikan Laporan Data Lengkap",
    shareFullDataReportDescription: "Buat Kode Akses, Ini akan memungkinkan penerima untuk mengimpor data DDS ke akun mereka sendiri.",
    iyb: {
      importSpreadsheetTitle: "Impor Spreadsheet Skor IYB",
      uploadFile: "Unggah File",
      previewData: "Pratinjau Data",
      confirmImport: "Konfirmasi Impor",
      uploadPtsiSpreadsheet: "Unggah Spreadsheet PTSI",
      uploadDescription: "Unggah spreadsheet IYBv2 BOGOR yang disediakan oleh PTSI. File ini berisi Status Risiko EUDR dan 13 skor indikator untuk 514 kabupaten di Indonesia.",
      acceptedFormats: "Format yang diterima",
      or: "atau",
      clickOrDragFileHere: "Klik atau seret & jatuhkan file IYBv2 BOGOR di sini",
      acceptsCsvOrXlsx: "Menerima .csv atau .xlsx",
      dataYear: "Tahun Data",
      selectYearHint: "Pilih tahun yang diwakili data IYB ini. Data tahun sebelumnya akan tetap tersimpan.",
      previewImportData: "Pratinjau Data Impor",
      showingRows: "Menampilkan baris {from} - {to}",
      totalRegenciesFound: "Total kabupaten ditemukan",
      records: "record",
      firePreventionTooltip: "Kebakaran Hutan & Lahan (IYBv2 BOGOR ind2). Untuk Kelapa Sawit: Merah (≤40) memblokir pengajuan DDS.",
      lowRiskFastTrack: "Risiko Rendah → HIJAU (jalur cepat)",
      mediumRiskMitigation: "Risiko Sedang → KUNING (mitigasi)",
      highRiskAppealPath: "Risiko Tinggi → MERAH (jalur banding)",
      proceedToConfirm: "Lanjut ke Konfirmasi",
      confirmImportDescription: "Impor akan menambah atau memperbarui skor IYB untuk {total} kabupaten pada tahun {year}. Skor untuk tahun lain tidak akan terpengaruh.",
      totalRegencies: "Total Kabupaten",
      importNow: "Impor Sekarang",
      regencyId: "ID Kabupaten",
      regencyName: "Nama Kabupaten",
      iybScore: "Skor IYB",
      firePrevention: "Pencegahan Kebakaran",
      eudrRiskStatus: "Status Risiko EUDR",
      iybScores: "Skor IYB",
      importSpreadsheet: "Impor Spreadsheet",
      noDataFound: "Data tidak ditemukan",
      noValidRegencyRows: "Spreadsheet tidak berisi baris kabupaten yang valid.",
      previewFailed: "Pratinjau gagal",
      couldNotParseSpreadsheet: "Tidak dapat memproses spreadsheet",
      couldNotLoadPreviewPage: "Tidak dapat memuat halaman pratinjau",
      importSuccessTitle: "Skor IYB berhasil diimpor",
      regenciesImported: "{count} kabupaten diimpor",
      importFailed: "Impor gagal",
      couldNotImportSpreadsheet: "Tidak dapat mengimpor spreadsheet",
      iybRegionalScores: "Skor Regional IYB",
      iybRegionalScoresSubtitle: "Skor indikator yurisdiksi berkelanjutan tingkat kabupaten dari PTSI. Digunakan untuk Fase 2 pemeriksaan kepatuhan EUDR Traffic Light.",
      allIndonesiaDistricts: "Semua kabupaten Indonesia",
      greenLowRisk: "HIJAU — Risiko Rendah",
      fastTrackEligible: "Layak jalur cepat",
      yellowMediumRisk: "KUNING — Risiko Sedang",
      mitigationRequired: "Mitigasi diperlukan",
      redHighRisk: "MERAH — Risiko Tinggi",
      blockedAppealPath: "Diblokir, tersedia jalur banding",
      searchRegencyName: "Cari nama kabupaten...",
      filterByTier: "Filter berdasarkan level",
      year: "Tahun",
      details: "Detail",
      failedToLoadScores: "Gagal memuat skor IYB",
      indicatorBreakdownTitle: "Rincian Indikator IYB",
      riskLabelZero: "Nol",
      notAvailable: "T/A",
      regencyKabupaten: "Kabupaten",
      environmental: "Lingkungan",
      socialAgricultural: "Sosial & Pertanian",
      governance: "Tata Kelola",
      scoreRanges: "Rentang skor:",
      lowRiskRange: "Risiko Rendah (≥60)",
      mediumRiskRange: "Risiko Sedang (40.01–59.99)",
      highRiskRange: "Risiko Tinggi (≤40)",
      trafficLightPanel: {
        viewAssessmentConditions: "Lihat kondisi penilaian",
        landAssessmentNotYetRun: "Penilaian lahan belum dijalankan",
        landAssessmentNotYetRunDesc: "Jalankan verifikasi untuk menilai pemeriksaan poligon berbasis peta (buffer hutan 100 m) dan skor IYB kabupaten (Kabupaten).",
        landPolygonAssessment: "Penilaian Poligon Lahan",
        landPolygonAssessmentDesc: "Analisis berbasis peta dengan buffer batas hutan 100 m",
        landPolygonAssessmentPreviewDesc: "Analisis deforestasi berbasis peta, tumpang tindih hutan lindung & buffer 100 m",
        districtAssessment: "Penilaian Kabupaten (Kabupaten)",
        districtAssessmentDesc: "Indeks keberlanjutan IYB tingkat kabupaten",
        showIndicators: "Tampilkan indikator",
        hideIndicators: "Sembunyikan indikator",
        unknownRegency: "Kabupaten Tidak Dikenal",
        localComplianceCheckIyb: "Pemeriksaan Kepatuhan Lokal (IYB)",
        outOf100: "dari 100,00",
        noIybDataForRegency: "Tidak ada data IYB untuk kabupaten ini",
        importIybToComplete: "Impor skor regional IYB untuk menyelesaikan penilaian.",
        palmOilFirePreventionCheck: "Kelapa Sawit — Pemeriksaan Pencegahan Kebakaran",
        palmOilFirePreventionCheckDesc: "Indikator Pencegahan Kebakaran Hutan tingkat kabupaten (IYBv2 BOGOR — ind2)",
        iybIndicatorScale: "Indikator IYBv2 BOGOR (ind2) — skala 0–100",
        palmOilDdsBlocked: "DDS Kelapa Sawit Diblokir — Tidak Ada Jalur Mitigasi",
        palmOilDdsBlockedDesc: "Kabupaten ini diklasifikasikan sebagai Merah untuk Pencegahan Kebakaran Hutan (indikator ≤ 40). Dalam kerangka kepatuhan lokal Kelapa Sawit, tidak ada jalur mitigasi. DDS ini tidak dapat dilanjutkan ke pengajuan PTSI untuk ekspor Kelapa Sawit UE.",
        firePreventionCheckPassed: "Pemeriksaan Pencegahan Kebakaran Lulus — Analisis Kelembapan Satelit Diperlukan",
        firePreventionCheckPassedGreen: "Kabupaten memenuhi ambang pencegahan kebakaran (indikator ≥ 60). Lanjutkan ke analisis kelembapan tanah/vegetasi satelit.",
        firePreventionCheckPassedYellow: "Kabupaten berada dalam rentang pencegahan kebakaran sedang (40–60). Analisis kelembapan tanah/vegetasi satelit diperlukan sebelum pengajuan PTSI.",
        noFireIndicatorData: "Tidak ada data indikator Kebakaran Hutan & Lahan untuk kabupaten ini. Impor skor regional IYB untuk mengaktifkan pemeriksaan pencegahan kebakaran Kelapa Sawit.",
        wildfireAlertTitle: "Peringatan Kerentanan Kebakaran Hutan",
        wildfireAlertDesc: "Laporan risiko kebakaran tingkat lahan berdasarkan data satelit/cuaca",
        wildfireAlertGenerated: "Laporan Dibuat",
        wildfireAlertLoading: "Memeriksa peringatan kebakaran yang sudah dibuat...",
        wildfireAlertNotFound: "Belum Dibuat",
        wildfireAlertNotFoundDesc: "Belum ada laporan kerentanan kebakaran yang dibuat untuk lokasi produksi ini.",
        wildfireAlertNoGeometry: "Batas Lahan Tidak Tersedia",
        wildfireAlertNoGeometryDesc: "Tidak ada data batas lahan atau lokasi untuk lokasi produksi ini, sehingga laporan kerentanan kebakaran tidak dapat dibuat.",
        wildfireAlertGenerating: "Membuat laporan kerentanan kebakaran — ini dapat memerlukan waktu hingga beberapa menit pada permintaan pertama...",
        wildfireAlertSaving: "Menyimpan laporan kerentanan kebakaran...",
        wildfireAlertReadyDesc: "Laporan berhasil dibuat — rincian kerentanan kebakaran ditampilkan di bawah",
        wildfireAlertClickToGenerate: "Klik Buat untuk meminta laporan kerentanan kebakaran untuk lahan ini",
        wildfireAlertGenerate: "Buat Laporan",
        wildfireAlertRegenerate: "Buat Ulang",
        wildfireAlertGenerateFailed: "Gagal membuat laporan kerentanan kebakaran. Silakan coba lagi.",
        wildfireAlertAreaLabel: "Luas Lahan",
        wildfireAlertModelLabel: "Model",
        wildfireAlertPolygonBoundary: "Batas Poligon",
        wildfireAlertCircularArea: "Area Lingkaran",
        wildfireAlertGeneratedOn: "Dibuat",
        wildfireAlertRiskBreakdownTitle: "Rincian Risiko berdasarkan Area",
        wildfireAlertHighestRisk: "Risiko Tertinggi",
        wildfireAlertRiskLevelColumn: "Tingkat Risiko",
        wildfireAlertAreaColumn: "Area (ha)",
        wildfireAlertShareColumn: "Persentase",
        wildfireAlertOverlayOpacity: "Opasitas overlay",
        mitigationEvidence: "Bukti Mitigasi",
        uploadedDocuments: "Dokumen yang diunggah",
        view: "Lihat",
        remove: "Hapus",
        clickToUploadOrDrop: "Klik untuk mengunggah atau seret & jatuhkan",
        fileTypesMaxSize: "PDF, JPG, PNG, DOCX — maks. 10 MB per file",
        ready: "Siap",
        failed: "Gagal",
        uploadFailed: "Unggahan gagal",
        uploadingToStorage: "Mengunggah file ke penyimpanan aman... | Mengunggah file ke penyimpanan aman...",
        submitEvidenceToPtsi: "Kirim Bukti ke PTSI",
        submittingToPtsi: "Mengirim ke PTSI...",
        fileExceedsLimit: "{name} melebihi batas 10 MB.",
        couldNotOpenMitigationDoc: "Tidak dapat membuka dokumen mitigasi.",
        mitigationDocument: "Dokumen mitigasi",
        fileCount: "{count} file | {count} file",
        phase1AllClear: "Semua Jelas",
        phase1OneIssue: "1 Masalah Ditemukan",
        phase1IssuesFound: "{count} Masalah Ditemukan",
        fireRiskLow: "Risiko Kebakaran: Rendah",
        fireRiskMedium: "Risiko Kebakaran: Sedang",
        blocked: "DIBLOKIR",
        lowRiskGte60: "Risiko Rendah ≥60",
        mediumRisk: "Risiko Sedang",
        highRiskLte40: "Risiko Tinggi ≤40",
        conditionsDocPalmOil: "Kelapa Sawit — Adendum Kepatuhan Lokal",
        conditionsDocCoffeeCocoa: "Adendum Kopi/Kakao V2.1",
        legendFarmBoundary: "Batas perkebunan",
        legendDeforestation: "Deforestasi",
        legendProtectedForest: "Hutan lindung",
        legend100mBuffer: "Buffer 100m",
        spatialDeforestationLabel: "Deforestasi terdeteksi (pasca-2020)",
        spatialDeforestationShort: "Deforestasi",
        spatialDeforestationHint: "Kehilangan hutan pasca-2020",
        spatialForestOverlapLabel: "Tumpang tindih hutan lindung/konservasi",
        spatialForestOverlapShort: "Tumpang Tindih Hutan",
        spatialForestOverlapHint: "Kawasan lindung",
        spatialBufferLabel: "Dalam 100m dari batas hutan",
        spatialBufferShort: "Buffer 100m",
        spatialBufferHint: "Kedekatan batas hutan",
        chipDetected: "Terdeteksi",
        chipOverlap: "Tumpang Tindih",
        chipWithin100m: "Dalam 100m",
        chipClear: "Jelas",
        phase1TooltipTitle: "Fase 1 — {label}",
        checkpointResult: "Hasil pemeriksaan: {result}",
        spatialDeforestationFail: "Analisis satelit mendeteksi kehilangan hutan pasca-2020 di dalam batas perkebunan. Ini adalah pemeriksaan spasial kritis dan biasanya memicu klasifikasi risiko tinggi.",
        spatialDeforestationPass: "Tidak ada kehilangan hutan pasca-2020 yang terdeteksi di dalam batas perkebunan.",
        spatialForestOverlapFail: "Poligon perkebunan tumpang tindih dengan batas hutan lindung (buffer 100 m diterapkan dari tepi hutan). Rilis mendatang akan mengintegrasikan lapisan peta Indonesia untuk hutan lindung, hutan sosial, dan hutan masyarakat adat.",
        spatialForestOverlapPass: "Tidak ada tumpang tindih dengan kawasan hutan lindung atau konservasi yang terdeteksi dalam buffer batas 100 m.",
        spatialBufferWarn: "Batas perkebunan berada dalam 100 m dari tepi hutan. Sesuai kondisi penilaian, mitigasi mungkin diperlukan meskipun tanpa deforestasi langsung.",
        spatialBufferPass: "Perkebunan berada di luar buffer batas hutan 100 m.",
        iybIndexUnavailable: "Indeks keberlanjutan regional untuk {regency} tidak tersedia.",
        iybScoreSummary: "Skor IYB {regency}: {score} / 100,00 → {status}",
        regencyAssessed: "Kabupaten dinilai: {regency}",
        compositeIybScore: "Skor IYB komposit: {score} dari 100,00",
        scoreGreenFastTrack: "Skor ≥ {min} — Hijau / layak jalur cepat (risiko lokal rendah)",
        scoreYellowMitigation: "Skor {min}–{max} — Kuning / risiko lokal sedang (mitigasi direkomendasikan)",
        scoreRedMandatory: "Skor ≤ {max} — Merah muda / risiko yurisdiksi lokal tinggi (mitigasi wajib)",
        regionalRiskStatus: "Status risiko regional: {status}",
        indicatorBreakdownAvailable: "Rincian indikator tersedia — perluas di bawah untuk tutupan lahan, kebakaran, gambut, dan faktor IYB lainnya",
        localComplianceNotLoaded: "Data kepatuhan lokal belum dimuat untuk perkebunan ini.",
        mitigationNoteYellow: "Perkebunan ini memerlukan bukti tambahan sebelum PTSI dapat menyetujui DDS. Unggah dokumen mitigasi — jendela 90 hari berlaku.",
        mitigationNoteRed: "Meskipun diklasifikasikan berisiko tinggi, jalur mitigasi tersedia. Unggah bukti kepatuhan tingkat perkebunan untuk tinjauan PTSI.",
        unknownRegencyLower: "kabupaten tidak dikenal",
      },
      indicators: {
        spatialPlanning: "Perencanaan Tata Ruang",
        forestLandFires: "Kebakaran Hutan & Lahan",
        waterWaste: "Air & Limbah",
        climateAction: "Aksi Iklim",
        landExploitation: "Eksploitasi Lahan",
        independentSmallholders: "Petani Kecil Mandiri",
        farmerInstitutions: "Kelembagaan Petani",
        businessPartnerships: "Kemitraan Bisnis",
        indigenousCommunities: "Komunitas Adat",
        gender: "Gender",
        spbeInformation: "Informasi SPBE",
        sp4nLaporComplaints: "Pengaduan SP4N-LAPOR",
        fpicSop: "SOP FPIC",
      },
    },
  },
  diligenceGuide: {
    guide: "Panduan",
    downloadPdfManual: "Unduh Manual PDF",
    watchDemoVideo: "Tonton Video Demo",
    viewManualOnWeb: "Lihat Manual di Web",
  },
  welcomeScreenDiligenceGuide: {
    title: "Pusat Panduan Esensial Anda",
    description: `Jelajahi halaman Panduan Bantuan Sistem Due Diligence EUDR kami untuk sumber daya penting
          termasuk manual PDF, tutorial video, dan bantuan berbasis web. Berdayakan diri Anda untuk menavigasi platform secara efisien
          dan optimalkan alur kerja Anda.`,
    continueToTheDueDiligenceSystem: "Lanjutkan ke Sistem Due Diligence",
  },
  containerTypes: {
    standardDry: "Kontainer Kering Standar (20ft, 40ft)",
    highCube: "Kontainer Kubus Tinggi",
    openTop: "Kontainer Atas Terbuka",
    flatRack: "Kontainer Rak Datar",
    refrigerated: "Kontainer Berpendingin (Reefer)",
    tank: "Kontainer Tangki",
    ventilated: "Kontainer Berventilasi",
    insulated: "Kontainer Berinsulasi",
    platform: "Kontainer Platform",
    halfHeight: "Kontainer Setengah Tinggi",
    bulk: "Kontainer Curah",
  },
  assessmentStatus:{
    riskAssessmentSummary: "Ringkasan Penilaian Risiko",
    riskAssessmentSummaryTT: "Ringkasan Penilaian Risiko",
    totalNoOfFarms: "Jumlah Total Perkebunan",
    assessmentsCompleted: "Penilaian Selesai",
    assessmentsPending: "Penilaian Tertunda",
    requiredMitigation: "Mitigasi Diperlukan",
  }
};
